/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
/// <reference path="../../../d.ts/globalFunc.d.ts" />
import * as Encoding from 'encoding-japanese';
import * as THREE from 'three';
import * as marietta from '../..';
import * as marietta3d from '../../../marietta3d';
import { Point } from '../../core';
import * as graphicLibs from '../../graphicLibs';
import { ZipDeCompression } from '../../graphicLibs/compress/zipDecompression';
import {
  ALMOST_ZERO,
  BUILDING_TYPE_HOUSE,
  BUILDING_TYPE_MANSION, CONTROL_ACTIONMODE, ITEM_MODE_NO, MEASURE_LINE_TOGGLE_BUTTON_SELECTOR,
  PIN_TOGGLE_BUTTON_SELECTOR, SITE_EDITMODE, SITE_INPUT_MODE,
} from '../Constants';
import { GradeMasterCollection, PointCollection } from '../collection';
import { LinkType } from '../collection/ItemInfoCollection';
import { ItemControllerShitaePointInput } from '../control';
import { Shitae } from '../item';
import { WebCADUtil } from '../util';
import { AdditionalPinData } from './AddLidarPinManager';

import { AuxiliaryData } from '../util/LiDAR/AuxiliaryInterface';
import { PinConfirm } from '../view/dialog';

const fileDownload = require('js-file-download');

/** 「複数選択」モードボタンの要素ID（非PCのみ存在） */
const GROUP_SELECT_MODE_BUTTON_ID: string = 'checkGroupSelectMode';
/** モードボタンのアクティブ表示に使うCSSクラス */
const MODE_ACTIVE_CLASS_NAME: string = 'is-active';
/** グリッド割（吸着単位）のOFF指定値 */
const SNAP_UNIT_OFF: 'off' = 'off';
/** グリッド割（吸着単位）の既定値（1/2） */
const SNAP_UNIT_DEFAULT: number = 0.5;

export interface Points {
    p1: THREE.Vector2,
    p2: THREE.Vector2
}

export default class Plan2DManager {
  /**
   * Constructor
   */
  constructor() {
    this._snapUnit = 0.5;
  }

  // プラン情報
  domain: string; // 起動元ドメイン

  mode: string; // モード

  _buildingType: number; // 戸建てモード house: 0 /マンションモード mansion: 1 // const.BUILDING_TYPE_HOUSE,BUILDING_TYPE_MANSION
  set buildingType(_value: number) {
    this._buildingType = _value;
    if (_value === BUILDING_TYPE_MANSION) {
      (document).querySelectorAll('.floorBtnWrap').forEach((_elem: HTMLElement) => {

        const elem = _elem;
        if( elem.parentElement.id == "orbitFloorBtn3D" ){
          elem.style.display = 'block';
        }else{
          elem.style.display = 'none';
        };
      });
      (<HTMLLabelElement>document.querySelector('#menu3dOuter0 + label')).style.display = 'none';
      (<HTMLLabelElement>document.querySelector('#menu3dInner0 + label')).style.display = 'none';

      //計測ボタンの表示
      document.getElementById('btnMesureParent').style.display = 'block';

    } else {
      (document).querySelectorAll('.floorBtnWrap').forEach((_elem: HTMLElement) => {
        const elem = _elem;
        elem.style.display = 'block';
      });
      (<HTMLLabelElement>document.querySelector('#menu3dOuter0 + label')).style.display = 'block';
      (<HTMLLabelElement>document.querySelector('#menu3dInner0 + label')).style.display = 'block';
    }
    marietta.webcad.WebCADGlobal.itemMenuCategories.showHideMenuButtons();
    this.createPitchList();
  }
  get buildingType(): number {
    return this._buildingType;
  }

  //グレード
  grade:GradeMasterCollection = null;

  // 物件ID
  bukenId: number;

  // buken_name: string;

  article_id: string;
  division_id: string;
  plan_name:string;

  // 図面情報
  zumen_id: string;

  zumen_timestamp: string;

  zumen_name: string;

  planID: string = ''; // プランID

  operation_type: number = 1;

  // 管理者またはユーザーのモード
  startup_mode: number = 1;

  contracted_date:string;   //成約日

  title: string; // プラン名

  base_url: string; // 起動ドメインベースURL

  webcad_url: string; // コンテンツ保管ドメイン

  assets_url: string; // assetsのURL

  assets_3d_url: string; // assets3DのURL

  cadapi_url: string; // assets3DのURL

  web_api_plan_read: string;

  web_api_plan_save: string;

  api_url: string; // API用ドメイン

  //LiDARデーターの有無
  hasLiDAR: boolean;

  // LiDARデーター用プランID
  LiDAR_plan_id: string;

  // WebCADデーターの有無
  hasWebCAD: boolean;

  //物件の建物用途（起動パラメータ）
  building_usage_kubun:string;

  // 建物スタイル リストの取得
  get_grades_api_url: string;

  // シンボル共通工事コード取得API
  get_symbol_construction_codes: string;

  // 建物スタイルのアイテム リストを取得する
  get_grades_item_api_url: string;

  // グループ アイテム リストの取得
  get_group_item_api_url: string;

  // シンボル項目リストを取得
  get_symbol_item_api_url: string;

  // パース図保存API
  persepective_image_api_url: string;

  // プランドキュメント取得API
  get_document_api_url: string;

  // 企画ドキュメント取得API
  get_planning_document_api_url: string;

  // 認証トークン
  access_token: string;

  // LiDARページへのリンク
  lidar_url: string = '';

  _saved_url: string;

  set saved_url(_value: string) {
    this._saved_url = _value;
  }

  get saved_url(): string {
    if (this._saved_url === '' || this._saved_url === null || this._saved_url === 'null') return this.return_url;
    return this._saved_url;
  }

  return_url: string; // 遷移元URL

  page_id: string; // 画面ID

  userID: string; // UserID

  firstboot: string; // 起動モード

  currentPlaneVersion: string; // 現行のプランのバージョン番号

  areaData: marietta.webcad.collection.AreaDataCollection; // 面積情報

  sekisanData: marietta3d.AutoGen.PlanEstimate; // 積算情報

  measureLineData: marietta3d.AutoGen.object.AutoObjDimension[][]; // 寸法線情報

  buildStyleListData: Object = {}; // ビルドスタイル情報

  closeWebcadAfterEvent: boolean = false; // webcadを閉じるフラグ

  isParsingObjects: boolean = false; // true: XMLはいつ解析しているとき

  // domain: string;
  webcad_activation_url: string = 'https://webcad-ua.marietta.co.jp/api';

  // 軒の出、妻の出
  noki_de: number = 300;

  tsuma_de: number = 250;

  outerWallThickness: number = 200;

  // 保存有無
  hasBeenSaved: boolean = false;

  hasShownSketchInstruction: boolean = false;

  // 通り芯
  xCoords: number[];

  yCoords: number[];

  torishinAttribute: any = {
    lineColor: '#000000',
    strokearray: [20, 5, 5, 5],
  };

  // 補助ポイント 情報
  guidePointAttribute: any = {
    lineColor: '#000000',
  };

  // テキストアイテムの属性設定
  textAttribute: any = {
    text_color: '#000000',
    font_size: 12,
    is_bold: false,
    is_underline: false,
    is_italic: false,
    is_strike_through: false,
    text_alignment: 'left',
    rotation: 0,
  }

  // 戻り先GETつきURLの取得
  getReturnUrl = (): string => {
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.hasBeenSaved) {
      // 保存終了
      return `${marietta.webcad.WebCADGlobal.webcad2Dmanager.return_url}?id=${marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id}&page_id=${marietta.webcad.WebCADGlobal.webcad2Dmanager.page_id}&type=1`;
    }
    // 保存しないで終了
    return `${marietta.webcad.WebCADGlobal.webcad2Dmanager.return_url}?id=${marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id}&page_id=${marietta.webcad.WebCADGlobal.webcad2Dmanager.page_id}&type=2`;
  };

  // 敷地
  siteList: any;

  // アイテムガイドの表示、非表示
  private _guideVisible: boolean = false;

  get guideVisible(): boolean {
    // シェアモードでは切り替えできないため、常に非表示とする
    if (marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) return false;
    return this._guideVisible;
  }

  set guideVisible(value: boolean) {
    this._guideVisible = value;
    if (!value) {
      (<HTMLElement>document.getElementById('btnGuideLine').querySelector('.btnGuideOff')).style.display = 'none';
      (<HTMLElement>document.getElementById('btnGuideLine').querySelector('.btnGuideOn')).style.display = 'block';
      document.getElementById('checkGuideLine')?.classList.remove('is-active');
      if (marietta.webcad.WebCADGlobal.itemManager.itemController != null && marietta.webcad.WebCADGlobal.itemManager.itemController.itemguide) {
        marietta.webcad.WebCADGlobal.itemManager.itemController.hideItemGuide();
      }
    } else {
      (<HTMLElement>document.getElementById('btnGuideLine').querySelector('.btnGuideOn')).style.display = 'none';
      (<HTMLElement>document.getElementById('btnGuideLine').querySelector('.btnGuideOff')).style.display = 'block';
      document.getElementById('checkGuideLine')?.classList.add('is-active');
      if (marietta.webcad.WebCADGlobal.itemManager.itemController != null && marietta.webcad.WebCADGlobal.itemManager.itemController.itemguide) {
        marietta.webcad.WebCADGlobal.itemManager.itemController.showItemGuide();
      }
    }
    localStorage.setItem('guide', value ? '1' : '0');
  }

  // アイテムガイドの表示、非表示
  private _pinVisible: boolean = false;

  get pinVisible(): boolean {
    return this._pinVisible;
  }

  set pinVisible(value: boolean) {
    this._pinVisible = value;
    if (!value) {
      (<HTMLElement>document.getElementById('btnPin').querySelector('.btnPinOff')).style.display = 'none';
      (<HTMLElement>document.getElementById('btnPin').querySelector('.btnPinOn')).style.display = 'block';
      document.querySelectorAll(PIN_TOGGLE_BUTTON_SELECTOR).forEach((element) => element.classList.remove(MODE_ACTIVE_CLASS_NAME));
      document.getElementById('checkPin2').classList.remove('is-active');
    } else {
      (<HTMLElement>document.getElementById('btnPin').querySelector('.btnPinOn')).style.display = 'none';
      (<HTMLElement>document.getElementById('btnPin').querySelector('.btnPinOff')).style.display = 'block';
      document.querySelectorAll(PIN_TOGGLE_BUTTON_SELECTOR).forEach((element) => element.classList.add(MODE_ACTIVE_CLASS_NAME));
      document.getElementById('checkPin2').classList.add('is-active');
    }
    localStorage.setItem('pin', value ? '1' : '0');
  }

  private _displayMark: boolean = false;
  get displayMark(): boolean {
    return this._displayMark;
  }

  set displayMark(value: boolean) {
    this._displayMark = value;
    marietta.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_MARK_NO)?.forEach((item) => {
      if (value) {
        item.spt.element.style.opacity = '100';
        item.spt.element.style.pointerEvents = 'auto';
        item.showChildren();
      } else {
        item.spt.element.style.opacity = '0';
        item.spt.element.style.pointerEvents = 'none';
        item.hideChildren();
      }
    });
  }

  // ライン測定の表示/非表示を処理します
  private _displayLineMeasurement: boolean = true;

  get displayLineMeasurement(): boolean {
    return this._displayLineMeasurement;
  }

  set displayLineMeasurement(value: boolean) {
    this._displayLineMeasurement = value;
    if (!value) {
      document.querySelectorAll(MEASURE_LINE_TOGGLE_BUTTON_SELECTOR).forEach((element) => element.classList.remove(MODE_ACTIVE_CLASS_NAME));
    } else {
      document.querySelectorAll(MEASURE_LINE_TOGGLE_BUTTON_SELECTOR).forEach((element) => element.classList.add(MODE_ACTIVE_CLASS_NAME));
    }
    localStorage.setItem('size', value ? '1' : '0');
  }

  // ###############   ビュー管理###############
  /**
   * 現在の入力モード
   * */
  _currentModeNo: number = ITEM_MODE_NO.MODE_FITTING_NO;

  get currentModeNo(): number {
    return this._currentModeNo;
  }

  set currentModeNo(value: number) {
    // 保持
    this._currentModeNo = value;

    // モード毎に吸着単位を変更する機能を停止
    // //モード毎の設定
    // switch( this._currentModeNo ){
    //     caseITEM_MODE_NO.MODE_SITE_NO:
    //         changeFloor(1);
    //         break;
    //     //お部屋モード
    //     caseITEM_MODE_NO.MODE_STAIR_NO:
    //     caseITEM_MODE_NO.MODE_ROOM_NO:
    //         this.snapUnit = 0.5;
    //         break;
    //     //建具モード
    //     caseITEM_MODE_NO.MODE_FITTING_NO:
    //         this.snapUnit = 0.25;
    //         break;
    // }

    // レイヤーの表示変更
    marietta.webcad.WebCADGlobal.layerGroup.showLayer(this.currentModeNo, this.currentFloor);

    // アクションモードの設定
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updatecurrentActionModeFromItemMenu();

    // 敷地の有無で、方位のON/OFFを制御
    if (this._currentModeNo === ITEM_MODE_NO.MODE_SITE_NO) {
      document.getElementById('compassBox').classList.remove('disabled');

      // 入力済みの敷地がなければ、敷地の入力モードを開始する
      const floorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1) as marietta.webcad.layer.FloorLayer;
      const tarLayer = floorLayer.layer_site as marietta.webcad.layer.SiteLayer;
      const items = tarLayer.getAllChildren();
      if (items.length === 0) {
        (<HTMLLabelElement>document.getElementById('btnEditSiteFree').nextElementSibling).click();
      }
    } else {
      document.getElementById('compassBox').classList.add('disabled');
      (<HTMLElement>document.querySelector('.compassDropdownList')).style.display = 'none';
    }
  }

  /**
   * 現在の入力FLOOR
   * */
  _currentFloor: number = 1;

  get currentFloor(): number {
    return this._currentFloor;
  }

  set currentFloor(value: number) {
    // カレントをなくした状態にする
    marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;

    // 保持
    this._currentFloor = value;
    // レイヤーの表示変更
    marietta.webcad.WebCADGlobal.layerGroup.showLayer(this.currentModeNo, this.currentFloor);
  }

  private _isMultipleSelect: boolean = false;

  get isMultipleSelect(): boolean {
    return this._isMultipleSelect;
  }

  set isMultipleSelect(value: boolean) {
    this._isMultipleSelect = value;
    // ONにするときのみ選択モードへ切り替える。
    // （OFFはモード切替に伴う解除でも呼ばれるため、ここで選択モードへ戻すと切替先を打ち消してしまう）
    if (value) {
      this.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    }
    // 「複数選択」ボタンのアクティブ表示を同期（ボタンは非PCのみ存在）
    const groupSelectButton = document.getElementById(GROUP_SELECT_MODE_BUTTON_ID);
    if (groupSelectButton) groupSelectButton.classList.toggle(MODE_ACTIVE_CLASS_NAME, value);
  }

  /**
   * タブレット等でキー修飾（Shift/Ctrl）が使えない環境での「複数選択モード」中のタップ選択が有効か。
   * PCは Shift/Ctrl で複数選択するため対象外。選択モード中に限定する。
   */
  get isTapMultiSelectMode(): boolean {
    return !marietta.webcad.WebCADGlobal.userAgentManager.isPC
      && this._isMultipleSelect
      && this.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
  }

  inputCallback: Function;

  // UI変更におけるアクションモードの整理 160607 morimoto start

  /**
   * アクションモード
   */
  private _currentActionMode: number = 0;

  get currentActionMode() {
    return this._currentActionMode;
  }

  set currentActionMode(value: number) {
    this._currentActionMode = value;

    // 選択モード以外へ切り替わったら、複数選択モードは自動的に解除する
    if (value !== CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM && this._isMultipleSelect) {
      this.isMultipleSelect = false;
    }

    // 囲み入力モードの中断
    marietta.webcad.WebCADGlobal.itemManager.pointInputInterrupt();

    // 未配置アイテムの削除
    marietta.webcad.WebCADGlobal.itemManager.deleteUnplacedItems();

    /**
     * マウスカーソルの変更
     * 敷地編集の有効・無効設定
     */
    switch (this._currentActionMode) {
      case CONTROL_ACTIONMODE.ACTIONMODE_CONTROL_STAGE:
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = `url(${this.assets_url}img/grab.cur), move`;
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = false;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM:
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'default';
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = false;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = true;
        // if (this.mode != "2") $('.directionMark').hide();
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE:
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'default';
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = true;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE:
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'none';
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = false;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;

        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor !== 1) {
          marietta.webcad.WebCADGlobal.changeFloor(1);
          // console.error('敷地の操作は 1F で行ってください。');
          // return;
        }
        // marietta.webcad.WebCADGlobal.itemManager.startSiteInput();
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_ROOM:
        // 部屋種類が選択されていなければ選択モードへ変更
        if (!document.querySelector('#roomInputMenuItems').querySelector('input[type="radio"]:checked')) {
          this.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
          return;
        }

        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'none';
        if (this.buildingType === BUILDING_TYPE_MANSION) { (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'crosshair'; }
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = false;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;

        // カレントの削除
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;

        marietta.webcad.WebCADGlobal.itemManager.startRoomKakomiInput();
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_ROOM:
        // 部屋種類が選択されていなければ選択モードへ変更
        if (!document.querySelector('#roomInputMenuItems').querySelector('input[type="radio"]:checked')) {
          this.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
          return;
        }

        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'crosshair';
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = false;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;

        // カレントの削除
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;

        marietta.webcad.WebCADGlobal.itemManager.startRoomDragInput();
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_FITTING:
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'crosshair';
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = false;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;

        // カレントの削除
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;

        marietta.webcad.WebCADGlobal.itemManager.startFittingDragInput();
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_ROOF:
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'none';
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = false;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;

        marietta.webcad.WebCADGlobal.itemManager.startRoofInput();
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_TOUCH_MOBILE:
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'none';
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = false;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;
        marietta.webcad.WebCADGlobal.itemManager.startTouchInput(marietta.webcad.WebCADGlobal.webcad2Dmanager.inputCallback);
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_ROOM_SKETCH:
        // 部屋種類が選択されていなければ選択モードへ変更
        if (!document.querySelector('#roomInputMenuItems').querySelector('input[type="radio"]:checked')) {
          this.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
          return;
        }

        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'crosshair';
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = false;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;
        marietta.webcad.WebCADGlobal.itemManager.startRoomSketch();
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_FREE_CHARACTER:
        // テキストアイテムの作成プロセス
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'default';
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;
        // カレントの削除
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
        marietta.webcad.WebCADGlobal.itemManager.startFreeCharacterInput(false);
        break;
      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_PIN_TEXT:
        // テキストアイテムの作成プロセス
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'default';
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;
        // カレントの削除
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
        marietta.webcad.WebCADGlobal.itemManager.startFreeCharacterInput(true);

        //ピンの表示がない場合はアラートを表示する
        if( !marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible ){
          marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible = true;
        }

        break;

      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_PIN_PANORAMA:
        // テキストアイテムの作成プロセス
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'default';
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;
        // カレントの削除
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
        marietta.webcad.WebCADGlobal.itemManager.startPanoramaPinInput();

        //ピンの表示がない場合はアラートを表示する
        if( !marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible ){
          marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible = true;
        }
        break;

      case CONTROL_ACTIONMODE.ACTIONMODE_INPUT_WALL:
        (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'none';
        if (this.buildingType === BUILDING_TYPE_MANSION) { (<SVGElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'crosshair'; }
        // アイテム選択の有効・無効設定
        marietta.webcad.WebCADGlobal.layerGroup.siteEnabled = false;
        marietta.webcad.WebCADGlobal.layerGroup.itemEnabled = false;

        // カレントの削除
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;

        marietta.webcad.WebCADGlobal.itemManager.startWalliInput();
        break;
      default:
        break;
    }
  }

  _currentSiteEditMode: number = SITE_EDITMODE.SITE_EDIT_FREE_INPUT;

  get currentSiteEditMode(): number {
    return this._currentSiteEditMode;
  }

  set currentSiteEditMode(value: number) {
    this._currentSiteEditMode = value;
    // 囲み入力モードの中断
    marietta.webcad.WebCADGlobal.itemManager.pointInputInterrupt();

    // 未配置アイテムの削除
    marietta.webcad.WebCADGlobal.itemManager.deleteUnplacedItems();

    if (this._currentSiteEditMode !== SITE_EDITMODE.SITE_EDIT_COORDINATE_INPUT) {
      marietta.webcad.WebCADGlobal.itemManager.startSiteInput();
    }
  }

  _currentSiteInputMode: number = SITE_INPUT_MODE.SITE_SIMPLE_INPUT_MODE;

  get currentSiteInputMode(): number {
    return this._currentSiteInputMode;
  }

  set currentSiteInputMode(value: number) {
    this._currentSiteInputMode = value;
    const siteLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
    siteLayer.mode = this._currentSiteInputMode;
  }

  /**
   * 表示中のアイテムメニューからアクションモードを設定
   */
  updatecurrentActionModeFromItemMenu = () => {
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE;
    const siteLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
    switch (marietta.webcad.WebCADGlobal.itemMenu.currentMenuID) {
      case '#itemMenu_site':
        if (siteLayer.getAllChildren().length > 0) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = siteLayer.mode;
          if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE) {
            (<HTMLInputElement>document.getElementById('btnEditSiteTrianglular')).checked = true;
          } else {
            (<HTMLInputElement>document.getElementById('btnEditSiteFree')).checked = true;
          }
        } else {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = SITE_INPUT_MODE.SITE_SIMPLE_INPUT_MODE;
        }
        break;
      case '#itemMenu_room':
        if ((<HTMLInputElement>document.getElementById('btnRoomSelect')) && (<HTMLInputElement>document.getElementById('btnRoomSelect')).checked) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
        } else if ((<HTMLInputElement>document.getElementById('btnRoomDragInput')) && (<HTMLInputElement>document.getElementById('btnRoomDragInput')).checked) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_ROOM;
        } else if ((<HTMLInputElement>document.getElementById('btnRoomKakomiInput')) && (<HTMLInputElement>document.getElementById('btnRoomKakomiInput')).checked) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_ROOM;
        } else if (<HTMLInputElement>document.getElementById('btnRoomSketchInput') && (<HTMLInputElement>document.getElementById('btnRoomSketchInput')).checked) {
          if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.hasShownSketchInstruction) {
            marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.SketchInputInstructionDialog, false, true, false);
          } else {
            marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_ROOM_SKETCH;
          }
        } else {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
        }
        break;
      case '#itemMenu_fitting':
        if ((<HTMLInputElement>document.getElementById('btnFittingSelect')) && (<HTMLInputElement>document.getElementById('btnFittingSelect')).checked) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
        } else if ((<HTMLInputElement>document.getElementById('btnFittingDragInput')) != null && (<HTMLInputElement>document.getElementById('btnFittingDragInput')).checked) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_FITTING;
        } else if ((<HTMLInputElement>document.getElementById('btnFittingPut')) != null && (<HTMLInputElement>document.getElementById('btnFittingPut')).checked) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
        } else {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
        }
        break;
      default:
        marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
        break;
    }
  };

  /**
   * 部屋の壁リスト
   */
  private _roomWallList: marietta.webcad.collection.RoomWallCollection[];

  get roomWallList(): marietta.webcad.collection.RoomWallCollection[] {
    return this._roomWallList;
  }

  set roomWallList(value: marietta.webcad.collection.RoomWallCollection[]) {
    this._roomWallList = value;
  }

  /**
   * 壁リストを処理する
   *
   * @param itemXML
   */
  createRoomWallPoints(itemJson: any, building_type: number) {
    if (itemJson == null) {
      return;
    }
    let newRoomWallList = [];
    const manualWallList = [];
    // オブジェクト構造に変更
    const itemIndexList = itemJson;
    const itemList = [];
    let roomWallList: marietta.webcad.collection.RoomWallCollection;
    for (let i = 0, len = itemIndexList.length; i < len; i += 1) {
      if (parseInt(itemIndexList[i].f, 10) === marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) {
        if (building_type === BUILDING_TYPE_MANSION) {
          itemIndexList[i].start.x = marietta.webcad.util.WebCADUtil.convertMMToPix(itemIndexList[i].start.x);
          itemIndexList[i].start.y = marietta.webcad.util.WebCADUtil.convertMMToPix(itemIndexList[i].start.y);
          itemIndexList[i].end.x = marietta.webcad.util.WebCADUtil.convertMMToPix(itemIndexList[i].end.x);
          itemIndexList[i].end.y = marietta.webcad.util.WebCADUtil.convertMMToPix(itemIndexList[i].end.y);
        }
        roomWallList = new marietta.webcad.collection.RoomWallCollection();
        roomWallList.index = parseInt(itemIndexList[i].index, 10);
        roomWallList.id = itemIndexList[i].id;
        roomWallList.roomIndex = parseInt(itemIndexList[i].heya_idx_left, 10);
        roomWallList.floor = parseInt(itemIndexList[i].f, 10);
        roomWallList.start.x = parseInt(itemIndexList[i].start.x, 10);
        roomWallList.start.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseInt(itemIndexList[i].start.y, 10);
        roomWallList.start.wall_type = itemIndexList[i].start.wall_type;
        roomWallList.end.x = parseInt(itemIndexList[i].end.x, 10);
        roomWallList.end.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseInt(itemIndexList[i].end.y, 10);
        roomWallList.end.wall_type = itemIndexList[i].end.wall_type;
        if (roomWallList.id === 'manual') {
          if (itemIndexList[i].type === '1' || itemIndexList[i].type === '3') {
            roomWallList.start.wall_type = 1;
            roomWallList.end.wall_type = 1;
            manualWallList.push(roomWallList);
          }
        } else {
          itemList.push(roomWallList);
        }
      }
    }
    const obj = {};
    itemList.forEach((e) => {
      // i = e.roomIndex;
      if (obj[e.roomIndex]) obj[e.roomIndex].push(e);
      else obj[e.roomIndex] = [e];
    });
    Object.keys(obj).forEach((key) => {
      console.log(`${key} : ${obj[key]}`);
      const coll1: marietta.webcad.collection.RoomWallCollection[] = obj[key];
      Object.keys(obj).forEach((key1) => {
        if (key1 > key) {
          const coll2 = obj[key1];
          let i = coll1.length;
          while (i > 0) {
            i -= 1;
            if (this.isLineInsidePolygon(coll2, coll1[i])) {
              coll1.splice(i, 1);
              // continue;
            }
          }
        }
      });
      this.checkWallType(coll1);
      newRoomWallList = newRoomWallList.concat(coll1);
    });

    if (manualWallList.length > 0) {
      newRoomWallList = newRoomWallList.concat(manualWallList);
    }

    this.roomWallList = newRoomWallList;
  }

  /**
   * 線が多角形内にあるかどうかを確認
   * @param poly
   * @param line
   */
  isLineInsidePolygon(poly, line: marietta.webcad.collection.RoomWallCollection): boolean {
    const ptStart: marietta.core.Point = line.startPoint;
    const ptEnd: marietta.core.Point = line.endPoint;
    let isInside = false;
    if (!this.isPtOnEdge(poly, ptStart)) {
      if (this.isPointInsidePolygon(poly, ptStart)) {
        isInside = true;
      }
    }
    if (!isInside) {
      if (this.isPointInsidePolygon(poly, ptEnd)) {
        if (!this.isPtOnEdge(poly, ptEnd)) {
          isInside = true;
        }
      }
    }
    if (this.isPtOnEdge(poly, ptStart) && this.isPtOnEdge(poly, ptEnd)) {
      isInside = true;
    }
    return isInside;
  }

  /**
   * ポイントが多角形内にあるかどうかを確認
   * @param poly
   * @param point
   */
  isPointInsidePolygon = (poly, point: marietta.core.Point): boolean => {
    let c = false;
    // eslint-disable-next-line no-plusplus
    for (let i = -1, l = poly.length, j = l - 1; ++i < l; j = i) {
      // eslint-disable-next-line no-unused-expressions
      (((poly[i] as marietta.webcad.collection.RoomWallCollection).startPoint.y <= point.y && point.y < (poly[j] as marietta.webcad.collection.RoomWallCollection).startPoint.y) || ((poly[j] as marietta.webcad.collection.RoomWallCollection).startPoint.y <= point.y && point.y < (poly[i] as marietta.webcad.collection.RoomWallCollection).startPoint.y))
        // eslint-disable-next-line no-mixed-operators
        && point.x < (((poly[j] as marietta.webcad.collection.RoomWallCollection).startPoint.x - (poly[i] as marietta.webcad.collection.RoomWallCollection).startPoint.x) * (point.y - (poly[i] as marietta.webcad.collection.RoomWallCollection).startPoint.y)) / ((poly[j] as marietta.webcad.collection.RoomWallCollection).startPoint.y - (poly[i] as marietta.webcad.collection.RoomWallCollection).startPoint.y) + (poly[i] as marietta.webcad.collection.RoomWallCollection).startPoint.x
        && (c = !c);
    }
    return c;
  };

  /**
   * 壁タイプを確認し、0の場合は壁を削除する
   * @param collection
   */
  checkWallType = (collection: marietta.webcad.collection.RoomWallCollection[]) => {
    let i = collection.length;
    while (i > 0) {
      i -= 1;
      if (collection[i].start.wall_type === 0) {
        collection.splice(i, 1);
      }
    }
  };

  /**
   * 点が線分上に乗っているか。乗っている：true。
   * 戻り値：true = 線分内に乗っている。false = 線分上に無い。
   * @param poly
   * @param l2
   */
  isPtOnEdge = (poly, l2): boolean => {
    let status = false;
    for (let i = 0; i < poly.length; i += 1) {
      if (marietta.core.Point.distance(poly[i].startPoint, l2) < ALMOST_ZERO) {
        status = true;
      }
    }
    return status;
  };

  /**
   * 特定階の部屋頂点リストを取得する
   */
  getAllRoomPointList = (roomList: marietta.webcad.item.MonicaObject[]): number[][] => {
    const retList: any[] = [];
    for (let i: number = 0; i < roomList.length; i += 1) {
      if (roomList[i].itemInfo.lock !== true) {
        retList.push(roomList[i].itemInfo.globalDotListAsNumArray);
      }
    }
    return retList;
  }

  /**
     * すべてのエリアを再現する
     */
  updateRoomInfo() {
    // 現在の階の頂点リストを取得する
    console.log('area recreate');
    const roomList = <marietta.webcad.item.Room[]>(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_ROOM_NO)).getAllChildren();
    const allPointList = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllRoomPointList(roomList);

    marietta.webcad.WebCADGlobal.scene = new graphicLibs.Scene();
    if (allPointList.length > 0) {
      allPointList.forEach((pList: any) => {
          marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.ClosePath(pList));
      });
    }

    // 現在の階の建具の情報を足す
    const wallList = <marietta.webcad.item.WallObject[]>(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_WALL_NO)).getAllChildren();
    const wallPointList = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllWallPointList(wallList);
    for (let i = 0; i < wallPointList.length; i += 1) {
      const p1 = new THREE.Vector2(wallPointList[i][0].x, wallPointList[i][0].y);
      const p2 = new THREE.Vector2(wallPointList[i][1].x, wallPointList[i][1].y);
      marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.Line(p1, p2));
    }

    const polyList  = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.area();
    const outerList = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.outer();

    const { points } = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.pointlist;
    const outerPoints: Points[] = []; // 外側のポイントリスト
    outerList.forEach((outer: number[]) => {
      for (let i = 1; i <= outer.length; i += 1) {
          outerPoints.push({ p1: points[outer[i - 1]], p2: points[outer[i % outer.length]] });
      }
    });

    // 現在の階の全ての部屋を削除する
    const targetFloor: marietta.webcad.layer.FloorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor);
    targetFloor.formatLayersNewRoomCreations();
    const guidList: string[] = [];
    const areaPoints: Points[] = [];
    const usedOldRoomIndexes = [];
    // //新しい配列を元に部屋を生成する
    for (let i = 0; i < polyList.length; i += 1) {
      const polygon = polyList[i];
      if (polygon.length >= 3) {
        for (let j = 0; j < polygon.length - 1; j += 1) {
            areaPoints.push({ p1: polygon[j], p2: polygon[j + 1] });
        }
        areaPoints.push({ p1: polygon[polygon.length - 1], p2: polygon[0] });

        const dotList: PointCollection[] = marietta.webcad.util.WebCADUtil.convertPointListToRoomDotList(polygon);
        if (marietta.webcad.util.WebCADUtil.isAreaZero(dotList)) continue; // 面積0はアイテム作成しない

        const existingRoomInfo = marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveAreaInfo(roomList, dotList, usedOldRoomIndexes);

        let info: marietta.webcad.collection.ItemInfoCollection;
        if (existingRoomInfo.info != null) {
          info = existingRoomInfo.info.clone();
          marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveRoomWallInfo(info.globalDotList, dotList);
          info.index = undefined;
          info.x = 0;
          info.y = 0;
          if (guidList.indexOf(info.guid) > -1 || existingRoomInfo.hasShapeChange) info.guid = marietta.webcad.WebCADGlobal.getGuid();
          info.dotList = dotList;
        } else {
          info = new marietta.webcad.collection.ItemInfoCollection();
          info.x = 0;
          info.y = 0;
          info.id = String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
          info.guid = marietta.webcad.WebCADGlobal.getGuid();

          const defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
          info.dotList = dotList.map(dot => new marietta.webcad.collection.PointCollection(dot.x, dot.y, defaultRoomSetting.wallType, dot.guid));

          const textPos = new graphicLibs.utility.labelPosition().labelPosition(polygon);
          info.textPosition = new marietta.core.Point(textPos.x, textPos.y);
        }
        guidList.push(info.guid);
        marietta.webcad.WebCADGlobal.itemManager.createItem(info);
      }
    }

    const branch    = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.graph.branch();
    const wallpoints: Points[] = [];
    if (branch.length > 0) {
      const nodes = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.graph.adjacencyList;

      nodes.forEach((pointList: number[], index: number) => {
        const pos1: THREE.Vector2 = points[index];

        pointList.forEach((pointIndex: number) => {
          if (branch[index] === -1) return;
          if (pos1.clone().sub(points[pointIndex]).length() < 0.1) return; // 同じ位置に頂点がある場合は壁を作成しない

          if (!this.isSimilarLine({ p1: pos1, p2: points[pointIndex] }, wallpoints) && !this.isSimilarLine({ p1: pos1, p2: points[pointIndex] }, areaPoints)) {
            let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
            info.x = 0;
            info.y = 0;
            info.id = 'wal01_01';
            info.dotList = [new marietta.webcad.collection.PointCollection(pos1.x, pos1.y), new marietta.webcad.collection.PointCollection(points[pointIndex].x, points[pointIndex].y)];
            const oldInfo = this.retrieveWallObjectInfo(wallList, info.dotList);
            if (oldInfo != null) {
                info = oldInfo.clone();
            } else {
                info.guid = marietta.webcad.WebCADGlobal.getGuid();
            }
            marietta.webcad.WebCADGlobal.itemManager.createItem(info);
            wallpoints.push({ p1: pos1, p2: points[pointIndex] });
          }
        });
      });
    }

    const missingWalls: Points[] = this.findMissingWall(areaPoints, wallpoints, outerPoints); // 壁リストに含まれていない壁があるかどうかを確認
    if (missingWalls.length > 0) {
      missingWalls.forEach((wall: Points) => {
        if (wall.p1.clone().sub(wall.p2).length() < 0.1) return; // 同じ位置に頂点がある場合は壁を作成しない
        let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
        info.x = 0;
        info.y = 0;
        info.id = 'wal01_01';
        info.dotList = [new marietta.webcad.collection.PointCollection(wall.p1.x, wall.p1.y), new marietta.webcad.collection.PointCollection(wall.p2.x, wall.p2.y)];
        const oldInfo = this.retrieveWallObjectInfo(wallList, info.dotList);
        if (oldInfo != null) {
            info = oldInfo.clone();
        } else {
            info.guid = marietta.webcad.WebCADGlobal.getGuid();
        }
        marietta.webcad.WebCADGlobal.itemManager.createItem(info);
      });
    }
    // //スナップリストの作成
    marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();

    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
  }

  /**
   * ポイントリストを使用して部屋情報を取得する
   * @param oldList
   * @param newPointList
   * @returns
   */
  retrieveAreaInfo = (oldList: marietta.webcad.item.Room[], newPointList: PointCollection[], usedOldRoomIndexes: any[]) => {
    let status: boolean = false;
    let hasShapeChange: boolean = false;
    const filterByDiffrence = (arr1: PointCollection[], arr2: PointCollection[]) => {
      let res: PointCollection[] = [];
      res = arr1.filter((el: PointCollection) => !arr2.find((element: PointCollection) => marietta.core.Point.distance(element.point, el.point) === 0));
      return res;
    };

    const filterBySimilar = (arr1: PointCollection[], arr2: PointCollection[]) => {
      let res: PointCollection[] = [];
      res = arr1.filter((el: PointCollection) => arr2.find((element: PointCollection) => marietta.core.Point.distance(element.point, el.point) === 0));
      return res;
    };

    let count = 0;
    let old_count = 0;
    let oldIndex = null;
    const isSimilar = (collection1: PointCollection[], collection2: PointCollection[]) => {
      let similar = collection1.length === collection2.length && collection1.every((val: PointCollection) => collection2.find((c2) => marietta.core.Point.distance(val.point, c2.point) === 0) != null);
      if (similar) count = collection1.length;
      if (!similar) {
        const res = filterBySimilar(collection1, collection2);
        if (res.length >= 1) {
          count = res.length;
          const diff = filterByDiffrence(collection1, collection2);
          if (diff.length === 0) similar = true; // modified 25-02-22
          for (let i = 0; i < diff.length; i += 1) {
            let isOnline = false;
            for (let j = 0; j < collection2.length; j += 1) {
              if (j < collection2.length - 1) isOnline = marietta.webcad.util.WebCADUtil.isOnLine(collection2[j].point, collection2[j + 1].point, diff[i].point);
              else isOnline = marietta.webcad.util.WebCADUtil.isOnLine(collection2[j].point, collection2[0].point, diff[i].point);

              // WEBCADV15-1395 部屋を追加した際、既存の部屋の名称も一緒に変更されてしまう
              if (!isOnline) {
                const { isInside, isOnBorder } = marietta.webcad.util.WebCADUtil.pointIsInsidePolygon(collection2, diff[i].point);
                isOnline = !!((isInside || isOnBorder));
              }
              //
              if (isOnline) {
                count += 1;
                break;
              }
            }
            similar = isOnline;
            if (similar && res.length < collection2.length) hasShapeChange = true;
            if (similar === false) break;
          }
        }
      }
      return similar;
    };

    let roomInfo: marietta.webcad.collection.ItemInfoCollection | null = null;
    for (let i = 0; i < oldList.length; i += 1) {
      const oldRm = usedOldRoomIndexes.find((rm: any) => rm.index === i);
      if (!(oldRm && oldRm.count === 2)) {
        for (let j = 0; j < newPointList.length; j += 1) {
          const p = oldList[i].itemInfo.globalDotList.find((p1) => marietta.core.Point.distance(p1.point, newPointList[j].point) === 0);
          if (p !== undefined || p != null) {
            const similar = isSimilar(newPointList, oldList[i].itemInfo.globalDotList);
            if (similar) {
              status = true;
              if (count > old_count) {
                oldIndex = i;
                old_count = count;
              } else if (count === old_count) {
                if (oldIndex != null) {
                  if (oldList[oldIndex].itemInfo.globalDotList.length > oldList[i].itemInfo.globalDotList.length) {
                    oldIndex = i;
                    old_count = count;
                  }
                }
              }
              break;
            }
          }
        }
      }
    }
    if (status) {
      roomInfo = oldList[oldIndex].itemInfo;
      const old = usedOldRoomIndexes.find((rm: any) => rm.index === oldIndex);
      if (old) { old.count += 1; } else { usedOldRoomIndexes.push({ index: oldIndex, count: 1 }); }
    }
    return { info: roomInfo, hasShapeChange };
  }

  // 部屋の壁の情報を維持する
  retrieveRoomWallInfo = (oldList: marietta.webcad.collection.PointCollection[], newList: marietta.webcad.collection.PointCollection[]) => {
    for (let j = 1; j <= newList.length; j += 1) {
      const new1 = newList[j - 1];
      const new2 = newList[j % newList.length];
      let isOnline = false;
      for (let i = 1; i <= oldList.length; i += 1) {
        const old1 = oldList[i - 1];
        const old2 = oldList[i % oldList.length];
        if (marietta.webcad.util.WebCADUtil.isSimilarLine({
            p1: old1.point,
            p2: old2.point
        },
        {
            p1: new1.point,
            p2: new2.point
        })) {
            isOnline = true;
        }
        if (isOnline) {
            new1.wall_type = old1.wall_type;
            // new1.wall_height = old1.wall_height;
            new1.guid = newList.find((p) => p.guid === old1.guid) ? marietta.webcad.WebCADGlobal.getGuid() : old1.guid;
            new1.type = old1.type;
            break;
        } else {
            new1.wall_type = 1;
        }
      }
    }
  }


  /**
   * 現在の壁のポイントリストを返す
   */
  getAllWallPointList = (wallList: marietta.webcad.item.WallObject[]): PointCollection[][] => {
    const retList: any[] = [];
    for (let i: number = 0; i < wallList.length; i += 1) {
      if (wallList[i].itemInfo.lock !== true) {
        retList.push(wallList[i].itemInfo.globalDotList);
      }
    }
    return retList;
  }

  /**
  * 類似の行かどうかを見つける
  * @param line
  * @param lineList
  * @returns
  */
  isSimilarLine = (line: any, lineList: any[]) => {
    let status = false;
    for (let i = 0; i < lineList.length; i += 1) {
      if (((<THREE.Vector2>lineList[i].p1).distanceTo(line.p1) === 0 && (<THREE.Vector2>lineList[i].p2).distanceTo(line.p2) === 0)
        || ((<THREE.Vector2>lineList[i].p2).distanceTo(line.p1) === 0 && (<THREE.Vector2>lineList[i].p1).distanceTo(line.p2) === 0)) {
        status = true;
        break;
      }
    }
    return status;
  }

  // 壁アイテムの情報を維持する
  retrieveWallObjectInfo = (oldList: marietta.webcad.item.WallObject[], newList: marietta.webcad.collection.PointCollection[]) => {
    let info = null;
    for (let i = 0; i < oldList.length; i += 1) {
      let status = false;
      for (let j = 0; j < newList.length; j += 1) {
        if (marietta.webcad.util.WebCADUtil.isSimilarLine({ p1: oldList[i].itemInfo.globalDotList[0].point, p2: oldList[i].itemInfo.dotList[1].point }, { p1: newList[0].point, p2: newList[1].point })) {
          status = true;
          break;
        }
      }
      if (status) { info = oldList[i].itemInfo; break; }
    }
    return info;
  }

  /**
   * 壁リストに含まれていない壁があるかどうかを確認
   * @param area
   * @param wall
   * @param outer
   * @returns
   */
  findMissingWall(area: Points[], wall: Points[], outer: Points[]): Points[] {
    let includedInArea = true;
    let includedInWall = true;
    let canInclude = false;
    const missing: Points[] = [];
    for (let i = 0; i < outer.length; i += 1) {
      if (area.length > 0) includedInArea = this.isSimilarLine(outer[i], area);
      else includedInArea = false;

      if (wall.length > 0) includedInWall = this.isSimilarLine(outer[i], wall);
      else includedInWall = false;

      if (area.length > 0 && !includedInArea && !includedInWall) canInclude = true;
      else if (area.length === 0 && !includedInWall) canInclude = true;

      canInclude = !!((canInclude && !this.isSimilarLine(outer[i], missing)));

      if (canInclude) missing.push(outer[i]);
    }
    return missing;
  }

  wallList: marietta.webcad.item.parts.Wall[] = [];

  /**
   * 同じ階の壁一覧の更新
   */
  updateWallList(floor: number = null) {
    if (floor != null) {
      this.wallList = this.getWallListByFloor(floor);
    } else {
      this.wallList = this.getWallListByFloor(this.currentFloor);
    }
  }

  /**
   * 階リストの取得
   */
  getWallListByFloor(floor: number):marietta.webcad.item.parts.Wall[]  {
    let wallList:marietta.webcad.item.parts.Wall[] = [];
    // 初期化
    const tarLayer: marietta.webcad.layer.FloorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(floor);
    if (!tarLayer) return [];

    const roomList1: marietta.webcad.item.Room[] = tarLayer.layer_room.getAllChildren() as marietta.webcad.item.Room[];
    const roomList2: marietta.webcad.item.Room[] = tarLayer.layer_roomdown1.getAllChildren() as marietta.webcad.item.Room[];
    const roomList3: marietta.webcad.item.Room[] = tarLayer.layer_roomdown2.getAllChildren() as marietta.webcad.item.Room[];
    const roomList: marietta.webcad.item.Room[] = [...roomList1, ...roomList2, ...roomList3];
    const wallObjectList: marietta.webcad.item.WallObject[] = tarLayer.layer_wall.getAllChildren() as marietta.webcad.item.WallObject[];
    for (let i: number = 0; i < roomList.length; i += 1) {
      wallList = wallList.concat((roomList[i] as marietta.webcad.item.Room).wallObjList);
    }
    for (let i: number = 0; i < wallObjectList.length; i += 1) {
      wallList = wallList.concat((wallObjectList[i] as marietta.webcad.item.WallObject).wallObjList);
    }
    return wallList;
  }

  /**
  * 一番近い壁を探す
  * @return Wall
  */
  getClosestWallInfo(newPoint: marietta.core.Point) {
    this.updateWallList();
    // 近い壁を探す
    const closestWalls = [];
    let crossPoint: marietta.core.Point;
    let distance: number;
    for (let i: number = 0; i < this.wallList.length; i += 1) {
      crossPoint = marietta.webcad.util.WebCADUtil.calculateCrossPoint((this.wallList[i] as marietta.webcad.item.parts.Wall).startDotGlobalPoint, (this.wallList[i] as marietta.webcad.item.parts.Wall).endDotGlobalPoint, newPoint);
      if (crossPoint !== null) {
        distance = marietta.core.Point.distance(crossPoint, newPoint);
        if (distance <= 10) {
          closestWalls.push({ wall: this.wallList[i] as marietta.webcad.item.parts.Wall, distance, crossPoint });
        }
      }
    }
    if (closestWalls.length < 1) return null;
    return closestWalls;
  }

  /**
 *
 * @param p
 * @returns
 */
  getAdjascentWallList = (p: marietta.core.Point) => {
    const WallTextList: any = [];
    const adjascent = { wallTextList: [], wall: null, rooms: [] };
    const closestWalls = marietta.webcad.WebCADGlobal.webcad2Dmanager.getClosestWallInfo(p);
    if (closestWalls != null && closestWalls.length > 0) {
      const ob = closestWalls[0];
      adjascent.wall = ob;
      adjascent.rooms = [];
      for (let i = 0; i < closestWalls.length; i += 1) {
        const wall = closestWalls[i].wall as marietta.webcad.item.parts.Wall;
        const room = wall.parentObj as marietta.webcad.item.Room;
        adjascent.rooms.push(wall.parentObj);
        if (wall.index === 0) {
          WallTextList.push(room.wallGuideList[wall.index + 1]);
          WallTextList.push(room.wallGuideList[room.wallGuideList.length - 1]);
        } else if (wall.index === room.wallGuideList.length - 1) {
          WallTextList.push(room.wallGuideList[wall.index - 1]);
          WallTextList.push(room.wallGuideList[0]);
        } else {
          WallTextList.push(room.wallGuideList[wall.index - 1]);
          WallTextList.push(room.wallGuideList[wall.index + 1]);
        }
      }
    }
    adjascent.wallTextList = WallTextList;
    return adjascent;
  }

  /**
   * 部屋入力継続モード
   */
  private _continualInput: boolean;

  get continualInput(): boolean {
    return this._continualInput;
  }

  set continualInput(value: boolean) {
    this._continualInput = value;
  }
  // UI変更におけるアクションモードの整理 160607 morimoto end

  /**
   * 変更フラグ
   */
  _isChanged: boolean = false;

  get isChanged(): boolean {
    return this._isChanged;
  }

  set isChanged(value: boolean) {
    this._isChanged = value;
  }

  /**
   * 吸着単位
   */
  _snapUnit: number = 0.5;

  get snapUnit(): number {
    return this._snapUnit;
  }

  set snapUnit(_unit: number | 'off') {
    this._snapUnit = (_unit == 'off') ? 0 : _unit;

    if (document.getElementById('snapPitchList')) {
      const snapValue = (this._snapUnit === 0) ? 'off' : this._snapUnit;
      (<HTMLInputElement>document.getElementById('snapPitchList')).value = snapValue.toString();
    }
  }

  /** 戸建てか */
  public isHouse(): boolean {
    return (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_HOUSE);
  }

  /** マンションか */
  public isMansion(): boolean {
    return (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION);
  }

  /** スナップさせるかどうか */
  public isSnap(): boolean {
    // モジュール補正時のみグリッド割り（1/2・1/4等）を利用可能。フリー寸法時は refreshModuleUiForMode でOFF固定される。
    // スナップの有無は snapUnit（off=0）で判定する。
    if (this.snapUnit === 0) return false; // グリッド割りが off の時

    return true;
  }

  /**
   * 吸着単位（ピクセル）
   */
  _snapUnitPix: number = 30;

  get snapUnitPix(): number {
    if (this.snapUnit === 0.33) {
      return 20;
    }
    if (this.snapUnit === 0) {
      return 1;
    }
    return this.snapUnit * marietta.webcad.WebCADGlobal.PIX_IN_GRID;
  }

  /**
   * モジュールピッチ
   */
  _modulePitch: number = 910;

  get modulePitch(): number {
    return this._modulePitch;
  }

  set modulePitch(value: number) {
    // 不正値(範囲外/NaN)は現状値を維持し、有効値は整数化する（ゼロ除算・NaN伝播の防止）
    this._modulePitch = marietta.webcad.WebCADGlobal.moduleManager.normalizePitch(value);
    // ※モジュール選択コンボボックスは寸法モード（フリー寸法/モジュール補正）で管理するため、ここでは触らない
  }

  /**
   * フリー寸法でグリッド割をOFF固定にする直前の設定値（モジュール補正へ戻したときの復元用）。
   * null は「退避なし（フリー寸法によるOFF固定をしていない）」を表す。
   */
  private snapUnitBeforeFree: number | null = null;

  /**
   * 寸法モードに合わせてモジュールUI（コンボボックス表示・グリッド割欄の状態）を同期する。
   * ・グリッド割（スナップ）選択はフリー寸法・モジュール補正いずれも表示する。
   * ・フリー寸法時はグリッド割をOFF固定・変更不可（disabled）にする。
   *   このとき直前の設定値を退避し、モジュール補正へ戻したときに復元する
   *   （モジュール補正→フリー寸法→モジュール補正でユーザーの選択が失われないようにするため）。
   */
  public refreshModuleUiForMode(): void {
    const snapListElement = document.getElementById('snapPitchList') as HTMLSelectElement | null;
    const snapListWrapElement = document.getElementById('snapListWrap');
    // 入力欄・ドロップダウン選択肢の表示（モード・ピッチ値・編集可否）はコンボボックス（view）側に委譲する
    marietta.webcad.WebCADGlobal.modulePitchCombo?.syncToCurrentMode();
    // グリッド割（1/2・1/4等）はどちらのモードでも表示する
    if (snapListWrapElement) { snapListWrapElement.style.display = 'block'; }
    if (marietta.webcad.WebCADGlobal.moduleManager.isFree()) {
      // フリー寸法：グリッド割はOFF固定にし、変更できないようにする
      // ※フリー寸法中の再同期（ダイアログ「いいえ」・データ読込等）で退避値を上書きしないよう、初回のみ退避する
      if (this.snapUnitBeforeFree === null) { this.snapUnitBeforeFree = this.snapUnit; }
      this.snapUnit = SNAP_UNIT_OFF;
      if (snapListElement) { snapListElement.disabled = true; }
    } else {
      // モジュール補正：フリー寸法で退避したグリッド割を復元し、変更を許可する
      if (this.snapUnitBeforeFree !== null) {
        this.snapUnit = this.snapUnitBeforeFree;
        this.snapUnitBeforeFree = null;
      }
      if (snapListElement) { snapListElement.disabled = false; }
    }
  }

  /**
   * [3D] モデル、マテリアルのパラメータ
   */
  _modelParam: marietta.webcad.collection.ModelParamCollection = null;

  set modelParam(_param: marietta.webcad.collection.ModelParamCollection) {
    this._modelParam = _param;
  }

  get modelParam() {
    return this._modelParam;
  }

  /**
   * 寸法線ボタンの表示切替
   * @param true 「寸法線の表示」
   * @param false 「寸法線の非表示」
   */
  updateBtnSunpousen = (val: boolean) => {
    if (val) {
      (<HTMLElement>document.querySelector('#btnMeasureLine .btnNameOff')).style.display = 'none';
      (<HTMLElement>document.querySelector('#btnMeasureLine .btnNameOn')).style.display = 'block';
    } else {
      (<HTMLElement>document.querySelector('#btnMeasureLine .btnNameOn')).style.display = 'none';
      (<HTMLElement>document.querySelector('#btnMeasureLine .btnNameOff')).style.display = 'block';
    }
  };

  /**
   * 屋根メニューの更新
   */
  updateRoofMenuToCurrent = () => {
    const item = marietta.webcad.WebCADGlobal.itemManager.currentItem;
    // カレントアイテムに合わせて屋根メニューを更新する
    if (item == null || item instanceof marietta.webcad.item.Roof === false || (item instanceof marietta.webcad.item.Roof === true && item.itemInfo.roof_type === 3)) {
      (<HTMLInputElement>document.querySelector('#btnRoofSetting')).disabled = true;
    } else {
      (<HTMLInputElement>document.querySelector('#btnRoofSetting')).disabled = false;
    }
  };

  /**
   * サンプル読み込み
   * */
  readSample = (sampleNum: number) => {
    // 3D内観カメラ情報の初期化しておく
    marietta.view3d.webcad.View3dGlobal.shared.clearCameraState();
    const parseData = (info) => {
      const dataManager = marietta.webcad.util.WebcadJSONParser;
      const p = new Promise((resolve: Function) => {
        dataManager.reproduceWebCAD(info, false, true, resolve);
      });
      p.then(() => {
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
        }
        marietta.webcad.WebCADGlobal.webcad2Dmanager.resetHistory();
        marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
        marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
        marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
        marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
        marietta.webcad.WebCADGlobal.quotationItemList.createData();
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      }).catch((msg: any) => {
        console.log(msg);
      });
    };

    const url = `${this.assets_url}sample_plan/sample${String(sampleNum)}.json?${Math.floor(Math.random() * 10000)}`;
    fetch(url, { method: 'GET' })
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.text();
        }
        throw Error(response.statusText);
      }).then((info) => {
        let data;
        if (typeof info === 'object') {
          data = info;
        } else {
          data = JSON.parse(info);
        }
        if ((data.plan.building_type !== null && data.plan.building_type !== undefined)
          && (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType !== data.plan.building_type)) {
          marietta.webcad.WebCADGlobal.showAlert(`${data.plan.building_type === 0 ? '戸建て' : 'マンション'}モードに切り替わります。`, '', () => parseData(info));
        } else {
          parseData(info);
        }
      })
      .catch((error) => {
        console.log('error', error);
        console.error(`${url}の取得に失敗しました。`);
      });
  };

  getStringInArray = (str: string): string[] => {
    const array = [];
    let i;
    const il = str.length;
    for (i = 0; i < il; i += 1) array.push(str.charCodeAt(i));
    return array;
  };

  /**
   * インポート
   */
  readPlan = (e) => {
    // 3D内観カメラ情報の初期化しておく
    marietta.view3d.webcad.View3dGlobal.shared.clearCameraState();

    const file = e.target.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (ev) => {
      const text: string = (ev.target as FileReader).result as string;
      marietta.WebCADGlobal.itemManager.currentItem = null;
      const dataManager = marietta.webcad.util.WebcadJSONParser;
      const p = new Promise((resolve: Function) => {
        dataManager.reproduceWebCAD(text, false, true, resolve);
      });
      p.then(() => {
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
        }
        marietta.webcad.WebCADGlobal.webcad2Dmanager.resetHistory();
        marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
        marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
        marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
        marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
        marietta.webcad.WebCADGlobal.quotationItemList.createData();
        // 見積リストの所属部屋名を更新する
        marietta.webcad.WebCADGlobal.quotationItemList.updateRoomTextForAllTables();

        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
        marietta.webcad.WebCADGlobal.webcad2Dmanager.enableViewMode(true);
      }).catch((msg: any) => {
        console.log(msg);
      });
    });
    reader.readAsText(file, 'utf-8');
  };

  /**
   * エクスポート
   */
  exportPlan = (jsonData: String, filename?: string) => {
    if (filename) {
      fileDownload(jsonData, filename);
      return;
    }
    const datetime = new Date();
    const date = new Date().toISOString().slice(0, 10).split('-')
      .map((d) => parseInt(d, 10))
      .join('');
    const filename_ = `webcad_${date}${datetime.getHours()}${datetime.getMinutes()}${datetime.getSeconds()}.json`;
    fileDownload(jsonData, filename_);
  };

  /**
   * プランの読込
   */
  loadPlan = () => {
    const url = marietta.webcad.net.default.param.default.ActionName.GET;

    const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      if (response.status >= 200 && response.status <= 299) {
        return response.json();
      }
      throw Error(response.statusText);
    }).then((info) => {
      const webcadData = info.webcad_data;
      //成約日
      marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date = info.contracted_date;

      const dataManager = marietta.webcad.util.WebcadJSONParser;
      const d = new Promise((resolve: Function) => {
        dataManager.reproduceWebCAD(webcadData, false, true, resolve);
      });
      d.then(() => {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = false;

        // みんなの間取りの場合は、変更フラグが立つようにする
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.mode === 'template') {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = true;
        }

        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
        }
        marietta.webcad.WebCADGlobal.webcad2Dmanager.resetHistory();
        marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
        const itemList = marietta.webcad.WebCADGlobal.layerGroup.getAllItems();
        if (itemList.length > 0) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
        }
        marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
        marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
        marietta.webcad.WebCADGlobal.quotationItemList.createData();
        // 見積リストの所属部屋名を更新する
        marietta.webcad.WebCADGlobal.quotationItemList.updateRoomTextForAllTables();

        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

        const mouseDown = () => {
          if ((document.querySelector('#webcad3dView') as any).clickCount > 0) {
            (<HTMLElement>document.querySelector('#webcadClose > a')).click();
          } else {
            marietta.view3d.webcad.View3dGlobal.shared.go();
            (document.querySelector('#webcad3dView') as any).touchStartTime = Date.now();
          }
        };

        //グレードリストを取得
        if( marietta.webcad.WebCADGlobal.webcad2Dmanager.grade ){
          const p = new Promise((resolve: Function) => {
            marietta.webcad.WebCADGlobal.masterManager.getGradeItemMasterData( marietta.webcad.WebCADGlobal.webcad2Dmanager.grade.id, resolve);
          });
          p.then(( list:any[] = null ) => {
            //マスタに更新
            if( list ) marietta.WebCADGlobal.webcad2Dmanager.grade.updateItemList( list );
          });
        }

        const mouseUp = () => {
          console.log('touchend');
          marietta.view3d.webcad.View3dGlobal.shared.stop();
          if (Date.now() - (document.querySelector('#webcad3dView') as any).touchStartTime < 300) {
            (document.querySelector('#webcad3dView') as any).clickCount = 1;
            setTimeout(() => {
              (document.querySelector('#webcad3dView') as any).clickCount = 0;
            }, 300);
          }
        };
        marietta.webcad.WebCADGlobal.webcad2Dmanager.enableViewMode();
      }).catch((msg: any) => {
        console.log(msg);
      });
    }).catch(() => {
      // 保存しましたダイアログを表示する
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_IMPORT_FAIL'));
    });
  };

  // /**
  //  * OKボタンがクリックされた
  //  */
  // savePlan = (): void => {
  //   const url = marietta.webcad.WebCADGlobal.webcad2Dmanager.web_api_plan_save;
  //
  //   // XMLを文字列に変換
  //   const xml: XMLDocument = marietta.webcad.WebCADGlobal.webcad2Dmanager.getSaveData();
  //   const xml_serializer = new XMLSerializer();
  //   let xmlString: string = xml_serializer.serializeToString(xml);
  //   // eslint-disable-next-line no-useless-escape
  //   xmlString = xmlString.replace(/xmlns=\"http:\/\/www.w3.org\/1999\/xhtml\"/g, '');
  //
  //   const data: any = {
  //     data: {
  //       zumen_id: marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id.toString(),
  //       zumen_timestamp: marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_timestamp,
  //       zumen_data: xmlString,
  //     },
  //   };
  //
  //   // ビジーフィルタ
  //   marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_CONNECTING'));
  //
  //   fetch(url, {
  //     method: 'POST',
  //     body: data,
  //   }).then((response) => {
  //     if (response.status >= 200 && response.status <= 299) {
  //       return response.json();
  //     }
  //     throw Error(response.statusText);
  //   }).then((info) => {
  //     if (info.error === undefined) {
  //       // 現行プランのバージョン番号
  //       marietta.webcad.WebCADGlobal.webcad2Dmanager.currentPlaneVersion = marietta.webcad.WebCADGlobal.APP_VERSION;
  //
  //       // 前の図面id
  //       const previousZumenID: string = marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id;
  //
  //       // 戻ってきた情報を保持
  //       marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id = info.data.zumen_id;
  //       marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_timestamp = info.data.zumen_timestamp;
  //
  //       // 保存フラグ
  //       marietta.webcad.WebCADGlobal.webcad2Dmanager.hasBeenSaved = true;
  //
  //       // HideBusy
  //       marietta.webcad.WebCADGlobal.hideBusy();
  //
  //       // 排他チェック結果
  //       const isNotPreviousZumenID: boolean = Boolean(previousZumenID !== marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id);
  //
  //       // webcadを閉じるフラグが有効の場合は遷移する
  //       const { webcad2Dmanager } = marietta.webcad.WebCADGlobal;
  //       if (webcad2Dmanager.closeWebcadAfterEvent) {
  //         // 排他チェックに引っかかった場合は、閉じない
  //         if (!isNotPreviousZumenID) {
  //           // ページ更新確認ダイアログを一時的に解除
  //           window.removeEventListener('beforeunload', marietta.webcad.WebCADGlobal.pageBeforeUnload);
  //
  //           window.location.href = marietta.webcad.WebCADGlobal.webcad2Dmanager.getReturnUrl();
  //         } else {
  //           // 排他エラー
  //           marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('NOTICE_SAVED_EXCLUSION'));
  //         }
  //       } else {
  //         // 排他チェックに引っかかった場合は、別のメッセージを表示する
  //         if (!isNotPreviousZumenID) {
  //           // 保存しましたダイアログを表示する
  //           marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('NOTICE_SAVED'));
  //         } else {
  //           // 排他エラー
  //           marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('NOTICE_SAVED_EXCLUSION'));
  //         }
  //         // 変更フラグの解除
  //         marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = false;
  //       }
  //     } else {
  //       // HideBusy
  //       marietta.webcad.WebCADGlobal.hideBusy();
  //
  //       // エラーアラート表示
  //       // marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText("NOTICE_SAVE_ERROR_JP"));
  //
  //       let messageID: string;
  //       switch (true) {
  //         case Object.prototype.hasOwnProperty.call(info.error.messages, '4010'):
  //           messageID = '4010';
  //           break;
  //         case Object.prototype.hasOwnProperty.call(info.error.messages, '4011'):
  //           messageID = '4011';
  //           break;
  //         case Object.prototype.hasOwnProperty.call(info.error.messages, '4000'):
  //           messageID = '4000';
  //           break;
  //         case Object.prototype.hasOwnProperty.call(info.error.messages, '4001'):
  //           messageID = '4001';
  //           break;
  //         case Object.prototype.hasOwnProperty.call(info.error.messages, '4002'):
  //           messageID = '4002';
  //           break;
  //         case Object.prototype.hasOwnProperty.call(info.error.messages, '4040'):
  //           messageID = '4040';
  //           break;
  //         case Object.prototype.hasOwnProperty.call(info.error.messages, '4090'):
  //           messageID = '4090';
  //           break;
  //         case Object.prototype.hasOwnProperty.call(info.error.messages, '5000'):
  //           messageID = '5000';
  //           break;
  //         default:
  //           break;
  //       }
  //       console.log(messageID);
  //       // エラーをまとめて表示
  //       let errorString: string = '';
  //       if (info.error.code != null && info.error.code !== '') {
  //         errorString += `エラーコード：${info.error.code}<br>`;
  //       }
  //       for (let i = 0; i < info.error.messages.length; i += 1) {
  //         errorString += `${info.error.messages[i]}<br>`;
  //       }
  //       // エラーアラート表示
  //       marietta.webcad.WebCADGlobal.showAlert(errorString, '', () => {
  //         // 操作後、保存済みの場合は一覧へ戻す
  //         window.location.href = marietta.webcad.WebCADGlobal.webcad2Dmanager.getReturnUrl();
  //       });
  //     }
  //   }).catch(() => {
  //     // HideBusy
  //     marietta.webcad.WebCADGlobal.hideBusy();
  //
  //     // エラーメッセージの初期化
  //     marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('NOTICE_LOAD_ERROR'), '', () => {
  //       // 操作後、保存済みの場合は一覧へ戻す
  //       window.location.href = marietta.webcad.WebCADGlobal.webcad2Dmanager.getReturnUrl();
  //     });
  //   });
  // }

  /**
   * プランの保存
   */
  showSavePlanDialog = () => {
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.SavePlanDialog);
  };

  /**
   * プランの別名保存
   */
  showSaveAsPlanDialog = () => {
    const tarDialog: marietta.webcad.view.dialog.SavePlanDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.SavePlanDialog) as marietta.webcad.view.dialog.SavePlanDialog;
    tarDialog.showAsSaveAs();
  };

  /**
   * 保存データ
   */
  getSaveData = (): XMLDocument => {
    const retXML: XMLDocument = marietta.webcad.util.WebcadXMLExporter.createWebCADData();
    return retXML;
  };

  /**
   * 保存データ
   */
  getJSONSaveData = (): string => {
    const retJSON: string = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    return retJSON;
  };

  /**
   * quoteデータ
   */
  getJSONQuoteDataForSite = (): string => {
    let retData:{quotations:any} = {quotations: []};
    const retJSON = marietta.webcad.util.WebcadJSONExporter.quotationInfoJSONForSite();
    if( 0 < retJSON.length ){
      retData.quotations = retJSON;
    }
    return JSON.stringify(retData);
  };

  /**
   * ログインダイアログを表示した後、保存ダイアログを表示
   */
  showLoginDialogAndThenSaveDialog = () => {
    const tarDialog: marietta.webcad.view.dialog.LoginDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.LoginDialog) as marietta.webcad.view.dialog.LoginDialog;
    tarDialog.callBack = marietta.webcad.WebCADGlobal.webcad2Dmanager.showSavePlanDialog;
  };

  /**
   * ログインダイアログを表示した後、別名保存ダイアログを表示
   */
  showLoginDialogAndThenSaveAsDialog = () => {
    const tarDialog: marietta.webcad.view.dialog.LoginDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.LoginDialog) as marietta.webcad.view.dialog.LoginDialog;
    tarDialog.callBack = marietta.webcad.WebCADGlobal.webcad2Dmanager.showSaveAsPlanDialog;
  };

  /**
   * ログインチェック
   *
   */
  checkIfLoginAnd = (callBack: Function): void => {
    // シェアモードはアカウントを持たないため、ログインチェックを行わずに処理を続行する
    if (marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) {
      callBack();
      return;
    }

    const url = marietta.webcad.WebCADGlobal.webcad2Dmanager.domain + marietta.webcad.net.default.param.default.ActionName.IS_LOGIN;
    const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      if (response.status >= 200 && response.status <= 299) {
        return response.json();
      }
      throw Error(response.statusText);
    }).then((info) => {
      if (info.error === undefined) {
        callBack();
      } else if (info.error.code === 3) {
        // 認証エラーの時は、ログインダイアログを出す

        const dialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.LoginDialog);
        (dialog as marietta.webcad.view.dialog.LoginDialog).callBack = callBack;
      } else {
        marietta.webcad.WebCADGlobal.showAlert(info.error.message);
      }
    }).catch(() => {
      // アラート
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_LOGIN_ERROR'));
    });
  }

  /**
   * ログイン状態の確認
   * @ログインしている場合のcallback
   * @ログアウトしている場合のcallback
   */
  checkLogin = (cbLogin = null, cbLogout = null) => {
    // シェアモードはアカウントを持たないため、ログインチェックを行わない
    // 呼び出し元は保存・お問い合わせのため、どちらのcallbackも実行しない
    if (marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) {
      return;
    }

    const url = marietta.webcad.WebCADGlobal.webcad2Dmanager.domain + marietta.webcad.net.default.param.default.ActionName.IS_LOGIN;
    const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      if (response.status >= 200 && response.status <= 299) {
        return response.json();
      }
      throw Error(response.statusText);
    }).then((info) => {
      if (info.error === undefined) {
        if (cbLogin) cbLogin(info);
      } else if (cbLogout) cbLogout(info);
    }).catch(() => {
      // アラート
      // "ログインチェックに失敗しました。<br>ネットワーク環境をご確認ください。"
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_LOGIN_ERROR'));
    });
  };

  private _max: number = 20;

  private _historyPointer: number;

  private history: any[] = [];

  /**
     * 履歴を初期化する
  */
  resetHistory() {
    this.history = [];
    this._historyPointer = this.history.length - 1;
  }

  /**
   * ヒストリーに保管
   */
  saveToHistory() {
    // ポインターが別のところにあったら、ポインター以降の処理を削除
    if (this._historyPointer < this.history.length - 1) {
      this.history.splice(this._historyPointer + 1, this.history.length - this._historyPointer - 1);
    }

    // 上限に達したら前から削除
    if (this._max < this.history.length + 1) {
      this.history.shift();
    }

    // 部屋の編集・移動・天井の変更で居る所の天井高さが変わった UB を合わせ、同じ履歴に入れる
    marietta.webcad.util.UnitBathUtil.commit();

    // 履歴の JSON に入る仕様情報の行を、今のアイテムから作り直しておく（作り直せなくても履歴は積む）
    const quotationItemList: marietta.webcad.view.QuotationItemList = marietta.webcad.WebCADGlobal.quotationItemList;
    try {
      quotationItemList?.rebuildRows();
    } catch (error) {
      console.error(error);
    }

    const info: any = {
      currentFloor: this.currentFloor,
      data: this.getJSONSaveData(),
      scroll: marietta.webcad.manager.ScrollerManager.currentSetting,
      shitae1_x: null,
      shitae1_y: null,
      shitae2_x: null,
      shitae2_y: null,
      shitae3_x: null,
      shitae3_y: null,
    };

    let list: Shitae[] = marietta.webcad.WebCADGlobal.layerGroup.floorShitae1.layer_shitae.getAllChildren() as Shitae[];
    if (list.length) {
      info.shitae1_x = (list[0] as Shitae).itemInfo.x;
      info.shitae1_y = (list[0] as Shitae).itemInfo.y;
    }
    list = marietta.webcad.WebCADGlobal.layerGroup.floorShitae2.layer_shitae.getAllChildren() as Shitae[];
    if (list.length) {
      info.shitae2_x = (list[0] as Shitae).itemInfo.x;
      info.shitae2_y = (list[0] as Shitae).itemInfo.y;
    }
    list = marietta.webcad.WebCADGlobal.layerGroup.floorShitae3.layer_shitae.getAllChildren() as Shitae[];
    if (list.length) {
      info.shitae3_x = (list[0] as Shitae).itemInfo.x;
      info.shitae3_y = (list[0] as Shitae).itemInfo.y;
    }
    this.history.push(info);

    // console.log("saveToHistory-------------------------")
    // for( var i:number = 0; i < this.history.length; i++ ){
    //     console.log( this.history[i].shitae1_x + ",  " + this.history[i].shitae1_y )
    // }
    this._historyPointer = this.history.length - 1;
    console.log('ヒストリに保管', this._historyPointer, this.history.length, 'currentFloor:', this.currentFloor);

    // 状態の更新
    this.updateHistoryButtonStatus();

    // 保存フラグの更新
    this.isChanged = true;

    // 表の描き直しと見積APIは、操作が終わってから 1 回にまとめて行う
    quotationItemList?.requestRebuild();

    // 選んでいるアイテムのサイズが変わっていれば、フッターのサイズ欄に出す
    marietta.webcad.WebCADGlobal.itemControlPanel?.refreshSize();
  }

  /**
   * 履歴を積まない操作の確定（部屋設定・3D の高さ調整・グレード・アイテム変更・移動の各経路）
   * saveToHistory と同じく、UB の天井合わせ → 仕様情報の予約 → フッターのサイズ欄の順に行う
   */
  public commitWithoutHistory(): void {
    marietta.webcad.util.UnitBathUtil.commit();
    marietta.webcad.WebCADGlobal.quotationItemList?.requestRebuild();
    marietta.webcad.WebCADGlobal.itemControlPanel?.refreshSize();
  }

  /**
   * 下絵位置の復元
   */
  public updateShitaePositionToHistory() {
    let list: Shitae[];
    const info: any = this.history[this._historyPointer];

    list = marietta.webcad.WebCADGlobal.layerGroup.floorShitae1.layer_shitae.getAllChildren() as Shitae[];
    if (list.length && Object.prototype.hasOwnProperty.call(info, 'shitae1_x')) {
      (list[0] as Shitae).move(info.shitae1_x, info.shitae1_y);
    }
    list = marietta.webcad.WebCADGlobal.layerGroup.floorShitae2.layer_shitae.getAllChildren() as Shitae[];
    if (list.length && Object.prototype.hasOwnProperty.call(info, 'shitae2_x')) {
      (list[0] as Shitae).move(info.shitae2_x, info.shitae2_y);
    }
    list = marietta.webcad.WebCADGlobal.layerGroup.floorShitae3.layer_shitae.getAllChildren() as Shitae[];
    if (list.length && Object.prototype.hasOwnProperty.call(info, 'shitae3_x')) {
      (list[0] as Shitae).move(info.shitae3_x, info.shitae3_y);
    }
  }

  /**
   * アンドゥ
   */
  undo = () => {
    marietta.webcad.WebCADGlobal.overlapItemList.hideList();
    if (this._historyPointer - 1 < 0) return;
    this._historyPointer -= 1;

    // 下絵レイヤーインスタンスの保持
    this.keepShitaeLayer();

    const p = new Promise((resolve: Function) => {
      marietta.webcad.util.WebcadJSONParser.reproduceWebCAD(this.history[this._historyPointer].data, false, true, resolve);
    });
    p.then(() => {
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
        marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
      }

      // 階数の切り替え
      marietta.webcad.WebCADGlobal.changeFloor(this.history[this._historyPointer].currentFloor);

      // 拡大率とスクロールを元に戻す
      const setting: marietta.webcad.collection.ScrollSettingCollection = this.history[this._historyPointer].scroll;
      marietta.webcad.WebCADGlobal.scrollerManager.setScale(setting.scale);
      marietta.webcad.WebCADGlobal.scrollerManager.setScrollPosition(setting.x, setting.y);
      marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
      marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
      marietta.webcad.WebCADGlobal.quotationItemList.createData();

      // 状態の更新
      this.updateHistoryButtonStatus();
    }).catch((msg: any) => {
      console.log(msg);
    });

    // 変更フラグを立てる
    this.isChanged = true;
  };

  /**
   * リドゥ
   */
  redo = () => {
    marietta.webcad.WebCADGlobal.overlapItemList.hideList();
    if (this.history.length - 1 < this._historyPointer + 1) return;
    this._historyPointer += 1;

    // 下絵レイヤーインスタンスの保持
    this.keepShitaeLayer();
    const p = new Promise((resolve: Function) => {
      marietta.webcad.util.WebcadJSONParser.reproduceWebCAD(this.history[this._historyPointer].data, false, true, resolve);
    });
    p.then(() => {
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
        marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
      }
      // 階数の切り替え
      marietta.webcad.WebCADGlobal.changeFloor(this.history[this._historyPointer].currentFloor);

      // 拡大率とスクロールを元に戻す
      const setting: marietta.webcad.collection.ScrollSettingCollection = this.history[this._historyPointer].scroll;
      marietta.webcad.WebCADGlobal.scrollerManager.setScale(setting.scale);
      marietta.webcad.WebCADGlobal.scrollerManager.setScrollPosition(setting.x, setting.y);
      marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
      marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
      marietta.webcad.WebCADGlobal.quotationItemList.createData();
      // 状態の更新
      this.updateHistoryButtonStatus();
    }).catch((msg: any) => {
      console.log(msg);
    });

    // 変更フラグを立てる
    this.isChanged = true;
  };

  shitaeList: marietta.webcad.item.Shitae[];

  shitaeInfoList: marietta.webcad.collection.ItemInfoCollection[];

  /**
   * 下絵情報の保持
   */
  private keepShitaeLayer() {
    this.shitaeList = [];
    this.shitaeInfoList = [];
    let currentFloor: marietta.webcad.layer.FloorShitaeLayer;
    let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
    for (let i = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
      currentFloor = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i, true) as marietta.webcad.layer.FloorShitaeLayer;
      // 各階層の下絵情報の保持
      info = Object.assign(info, currentFloor.layer_shitae.defaultItemInfo);
      this.shitaeInfoList.push(info);

      // 各階層の下絵インスタンスの保持
      if (currentFloor.layer_shitae.childList.length > 0) {
        this.shitaeList.push(currentFloor.layer_shitae.childList[0] as Shitae);
      } else {
        this.shitaeList.push(null);
      }
    }
  }

  /**
   * Undo・Redoボタン状態の更新
   */
  updateHistoryButtonStatus() {
    // ボタンの表示変更
    if (this._historyPointer <= 0) {
      document.getElementById('btnUndo').classList.add('disabled');
      document.getElementById('btnUndo2').classList.add('disabled');
    } else {
      document.getElementById('btnUndo').classList.remove('disabled');
      document.getElementById('btnUndo2').classList.remove('disabled');
    }

    if (this._historyPointer >= this.history.length - 1) {
      document.getElementById('btnRedo').classList.add('disabled');
      document.getElementById('btnRedo2').classList.add('disabled');
    } else {
      document.getElementById('btnRedo').classList.remove('disabled');
      document.getElementById('btnRedo2').classList.remove('disabled');
    }
  }

  // キーボードが押されているか、記憶しておく用の配列
  public _input_key_buffer: any[] = [];

  /**
   * キーボードが押されているか調べる
   */
  keyIsDown(key_code: number): boolean {
    return this._input_key_buffer[key_code];
  }

  /**
   * キーボードが押された
   */
  onKeyDown = (e) => {
    // テキスト編集中であれば無視する
    if (document.activeElement && document.activeElement.getAttribute('type') === 'text') return;
    if (document.activeElement && document.activeElement.getAttribute('type') === 'number') return;
    if (document.activeElement && document.activeElement !== undefined && document.activeElement.tagName !== undefined && document.activeElement.tagName.toLowerCase() !== undefined && document.activeElement.tagName.toLowerCase() === 'textarea') return;
    switch (e.keyCode) {
      case 32: // SPACE
        e.preventDefault();
        // 既に押されている場合は終了
        if (this.keyIsDown(e.keyCode)) return;
        this._input_key_buffer[e.keyCode] = true;

        marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_CONTROL_STAGE;
        break;
      case 27: // ESCAPE
        // 屋根モードであれば、1点戻る
        if (marietta.webcad.WebCADGlobal.itemManager.itemController && marietta.webcad.WebCADGlobal.itemManager.itemController.cancelPreviousDot) {
          // 最後の点をキャンセル
          marietta.webcad.WebCADGlobal.itemManager.itemController.cancelPreviousDot();
        } else if (marietta.webcad.WebCADGlobal.itemManager.itemController && marietta.webcad.WebCADGlobal.itemManager.itemController instanceof ItemControllerShitaePointInput) {
          return;
        } else {
          // 既に押されている場合は終了
          if (this.keyIsDown(e.keyCode)) return;
          this._input_key_buffer[e.keyCode] = true;

          // 囲み入力モードの中断
          marietta.webcad.WebCADGlobal.itemManager.pointInputInterrupt();

          // 未配置アイテムの削除
          marietta.webcad.WebCADGlobal.itemManager.deleteUnplacedItems();

          // アクションモードアップデート
          this.currentActionMode = this._currentActionMode;
          if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE) {
            marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteEditMode = marietta.webcad.WebCADGlobal.webcad2Dmanager._currentSiteEditMode;
          }
        }
        break;
      case 37: // ←
      case 38: // ↑
      case 39: // →
      case 40: // ↓
        // アイテムが何も選択されていなければ実行しない
        if (!marietta.webcad.WebCADGlobal.itemManager.currentItem && !marietta.webcad.WebCADGlobal.itemManager.currentItemGroup) return;
        if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && !marietta.webcad.WebCADGlobal.itemManager.currentItem.isCapableOfMove()) {
          e.preventDefault();
          return;
        }
        if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup != null && !marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.isCapableOfMove()) {
          e.preventDefault();
          return;
        }
        // ダイアログが表示されていたら実行しない
        if (marietta.webcad.WebCADGlobal.currentDialog) return;
        // アイテムパネルのテキスト入力にフォーカスがあれば無視する
        if (document.activeElement === document.querySelector('#itemSizeWidth') || document.activeElement === document.querySelector('#itemSizeHeight')) return;
        e.preventDefault();
        if (e.keyCode === 37) marietta.webcad.WebCADGlobal.itemManager.moveItemFromkeyboard(-1, 0);
        else if (e.keyCode === 38) marietta.webcad.WebCADGlobal.itemManager.moveItemFromkeyboard(0, -1);
        else if (e.keyCode === 39) marietta.webcad.WebCADGlobal.itemManager.moveItemFromkeyboard(1, 0);
        else if (e.keyCode === 40) marietta.webcad.WebCADGlobal.itemManager.moveItemFromkeyboard(0, 1);
        break;
      case 8:
      case 46:
        // カレントアイテムがなければ無視する
        if (!marietta.webcad.WebCADGlobal.itemManager.currentItem && !marietta.webcad.WebCADGlobal.itemManager.currentItemGroup) return;
        if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && !marietta.webcad.WebCADGlobal.itemManager.currentItem.isCapableOfDelete()) {
          e.preventDefault();
          return;
        }
        if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup != null && !marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.isCapableOfDelete()) {
          e.preventDefault();
          return;
        }
        // ダイアログが表示されていれば無視する
        if( marietta.webcad.WebCADGlobal.isShowingBusy ) return;
        if ( ( marietta.webcad.WebCADGlobal.currentDialog != null && marietta.webcad.WebCADGlobal.currentDialog !== undefined ) && marietta.webcad.WebCADGlobal.currentDialog.hasModal ) return;

        // アイテムパネルのテキスト入力にフォーカスがあれば無視する
        if (document.activeElement === document.querySelector('#itemSizeWidth') || document.activeElement === document.querySelector('#itemSizeHeight')) return;

        // 削除キーが押された
        e.preventDefault();

        if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
          const p = new Promise((resolve: Function) => {
            marietta.webcad.WebCADGlobal.itemManager.currentItem.deleteMe(resolve);
          });
          p.then((msg: any) => {
            marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
            marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
            console.log(msg);
          }).catch((msg: any) => {
            console.log(msg);
          });
        }
        if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup != null && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup !== undefined) {
          marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.deleteSelectedItems();
          marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
        }
        break;
      // "C"
      case 67:
        // コピー
        if ((marietta.webcad.WebCADGlobal.itemManager.currentItem == null || marietta.webcad.WebCADGlobal.itemManager.currentItem === undefined) && (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup == null || marietta.webcad.WebCADGlobal.itemManager.currentItemGroup === undefined)) return;

        if (!marietta.webcad.WebCADGlobal.userAgentManager.isMac) {
          if (!e.ctrlKey) return;
        } else if (!e.metaKey) return;
        marietta.webcad.WebCADGlobal.itemManager.copyCurrentItemToMemory();
        break;
      // "V"
      case 86:
        // ペースト
        // if( marietta.webcad.WebCADGlobal.itemManager.currentItem == null || marietta.webcad.WebCADGlobal.itemManager.currentItem == undefined ) return;
        if (!marietta.webcad.WebCADGlobal.userAgentManager.isMac) {
          if (!e.ctrlKey) return;
        } else if (!e.metaKey) return;
        marietta.webcad.WebCADGlobal.itemManager.pasteCopiedItem();
        break;

      // "Y" key trigger
      // Redo option
      case 89:
        if (!marietta.webcad.WebCADGlobal.userAgentManager.isMac) {
          if (!e.ctrlKey) return;
        } else {
          return;
        }
        marietta.webcad.WebCADGlobal.webcad2Dmanager.redo();
        break;

      // "Z" key trigger
      // Undo option
      case 90:
        if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') return;
        if (!marietta.webcad.WebCADGlobal.userAgentManager.isMac) {
          if (!e.ctrlKey) return;
          marietta.webcad.WebCADGlobal.webcad2Dmanager.undo();
        } else if (e.metaKey && e.shiftKey) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.redo();
        } else if (e.metaKey) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.undo();
        }
        break;
      default:
        break;
    }
  };

  /**
   * キーボードが離された
   */
  onKeyUp = (e: KeyboardEvent) => {
    this._input_key_buffer[e.keyCode] = false;

    if (document.activeElement && document.activeElement.getAttribute('type') === 'text') return;
    if (document.activeElement && document.activeElement.getAttribute('type') === 'number') return;
    if (document.activeElement && document.activeElement !== undefined && document.activeElement.tagName !== undefined && document.activeElement.tagName.toLowerCase() !== undefined && document.activeElement.tagName.toLowerCase() === 'textarea') return;
    switch (e.keyCode) {
      case 32: // SPACE
        this.updatecurrentActionModeFromItemMenu();
        break;
      default:
        break;
    }
  };

  /**
   * コンフィグ情報の取得
   */
  getConfigInfo = (callBack: Function): void => {
    let url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url}assets/config.xml`;

    // 開発環境
    if (window.location.href.indexOf('localhost') > -1) {
      url = './assets/config.xml';
    }

    fetch(url, { method: 'GET' })
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.text();
        }
        throw Error(response.statusText);
      }).then((info) => {
        const datXML = new window.DOMParser().parseFromString(info, 'text/xml');
        // バージョン
        const version = datXML.querySelector('version').textContent
        marietta.webcad.WebCADGlobal.APP_VERSION = version;
        //document.querySelector('title').textContent = `WebCAD ver${version}`;

        // 表示する
        // $('#versionInfoBox #major').text(`ver. ${marietta.webcad.WebCADGlobal.APP_VERSION}`);

        // 自動回転アイテム
        let temp = datXML.querySelectorAll('system autoFacing item');
        for (let i: number = 0; i < temp.length; i += 1) {
          marietta.webcad.WebCADGlobal.AUTOFACING_ITEMS.push(temp[i].textContent);
        }

        // 3Dを持たないアイテム
        temp = datXML.querySelectorAll('system no3dItem item');
        for (let i: number = 0; i < temp.length; i += 1) {
          marietta.webcad.WebCADGlobal.NON3D_ITEMS.push(temp[i].textContent);
        }

        // 建具の高さ設定
        temp = datXML.querySelectorAll('system fittingManualSetting item');
        for (let i = 0; i < temp.length; i += 1) {
          marietta.webcad.WebCADGlobal.parseFittingSetting(<HTMLElement>temp[i]);
        }

        // Config情報取得
        callBack();
      }).catch((e) => {
        // 何もしない
        console.log(e);
        marietta.webcad.WebCADGlobal.showAlert('Configの取得に失敗しました。\n恐れ入りますが、リロードして下さい。');
      });
  };

  /**
   * 階数の選択の更新
   */
  updateFloorSelection() {
    // 表示階数の更新
    marietta.webcad.WebCADGlobal.changeFloor(this.currentFloor);
  }

  /**
   * アイテムの総数チェック
   * ※サーバAPIに送信する前にアイテム個数の制限をして、サーバ負荷を軽減します。
   */
  checkItemSize = (): string => {
    let romItems: number = 0;
    let fitItems: number = 0;
    const romItemMaxSize: number = 500;
    const fitItemMaxSize: number = 500;
    let tarFloor: marietta.webcad.layer.FloorLayer;
    let retMsg: string = '';

    for (let i = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
      tarFloor = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i);
      romItems += tarFloor.layer_roomdown1.childList.length;
      romItems += tarFloor.layer_roomdown2.childList.length;
      romItems += tarFloor.layer_room.childList.length;
      fitItems += tarFloor.layer_fitting.childList.length;
      fitItems += tarFloor.layer_fittingdown1.childList.length;
    }

    console.log('roomItems', romItems);
    console.log('fittingItems', fitItems);

    // 全フロアの部屋数をチェック
    if (romItems >= romItemMaxSize) retMsg += `部屋の数が${romItemMaxSize}を超えています。<br>`;
    if (fitItems >= fitItemMaxSize) retMsg += `建具の数が${fitItemMaxSize}を超えています。<br>`;
    if (retMsg !== '') retMsg += 'アイテム数を減らしてください。';
    return retMsg;
  };

  /**
   * エクスポート(積算情報)
   */
  exportSekisanData = () => {
    let csvString = 'data=';

    // 情報をパースする
    csvString += '基本情報\n';
    for (let i: number = 0; i < marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.gaibu.length; i += 1) {
      csvString += `${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.gaibu[i].code},`;
      csvString += `${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.gaibu[i].name},`;
      csvString += `${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.gaibu[i].value},`;
      csvString += `${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.gaibu[i].unit}\n`;
    }
    csvString += '部屋別情報\n';
    for (let i: number = 0; i < marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu.length; i += 1) {
      for (let k: number = 0; k < marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i].length; k += 1) {
        for (let n: number = 0; n < marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i][k].estimate.length; n += 1) {
          csvString += `${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i][k].estimate[n].code},`;
          csvString += `${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i][k].estimate[n].name},`;
          csvString += `${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i][k].estimate[n].value},`;
          csvString += `${marietta.webcad.WebCADGlobal.webcad2Dmanager.sekisanData.naibu[i][k].estimate[n].unit}\n`;
        }
        csvString += '\n';
      }
    }
    try {
      const datetime = new Date();
      const date = new Date().toISOString().slice(0, 10).split('-')
        .map((d) => parseInt(d, 10))
        .join('');
      const filename = `integration_${date}${datetime.getHours()}${datetime.getMinutes()}${datetime.getSeconds()}.csv`;
      // SJISに変換
      const unicodeArray = Encoding.stringToCode(csvString);
      const sjisArray = Encoding.convert(unicodeArray, 'SJIS', 'UNICODE');
      const blob = new Blob([new Uint8Array(sjisArray)], { type: 'text/csv;charset=shift_jis;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_EXPORT_SEKISAN_FAIL'));
    }
  };

  /**
   * エクスポート(JWW)
   */
  exportPlanJWW = () => {
    // 1Fに玄関がなければ、実行しない
    const floorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1) as marietta.webcad.layer.FloorLayer;
    const tarLayer = floorLayer.layer_fitting as marietta.webcad.layer.ItemLayer;
    const items = tarLayer.getAllChildren();
    if (items.length < 1) {
      // "JWW出力には玄関が必要です。<br>玄関を入力してください。"
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_JWW_ENTRANCE'));
      return;
    }
    const postUrl = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.cadapi_url}api/export_jww`;

    // Jsonを文字列に変換
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    fetch(postUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: reqJson,
    }).then((response) => {
      if (response.status >= 200 && response.status <= 299) {
        return response.json();
      }
      throw Error(response.statusText);
    }).then((info) => {
      const resetEventTime = 60 * 1000;
      // ページ更新確認ダイアログを一時的に解除
      window.removeEventListener('beforeunload', marietta.webcad.WebCADGlobal.pageBeforeUnload);
      if (info.status === 'SUCCESS') {
        const datetime = new Date();
        const date = new Date().toISOString().slice(0, 10).split('-')
          .map((d) => parseInt(d, 10))
          .join('');
        const filename = `webcad_${date}${datetime.getHours()}${datetime.getMinutes()}${datetime.getSeconds()}`;
        const linkSource = `data:application/octet-stream;base64,${info.jww_binary_base64}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = `${filename}.jww`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        marietta.webcad.WebCADGlobal.hideBusy();
      }
      // ページ更新確認ダイアログイベントを再設定
      setTimeout(() => {
        window.addEventListener('beforeunload', marietta.webcad.WebCADGlobal.pageBeforeUnload);
      }, resetEventTime);
    }).catch(() => {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_EXPORT_JWW_FAIL'));
    });
  };
  /**
   * エクスポート(DXF) — 単一/複数ファイルに対応（小数・小容量向け）
   */
  exportPlanDXF = async () => {
    if (!this.errorCheckExportPlanDXF(0)) {
      // "部屋がありません。<br>部屋を入力してください。"
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_NO_ROOMS'));
      return;
    }
    const baseUrl = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.cadapi_url}api/export_dxf`;
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();

    // ページ更新確認ダイアログを一時的に解除
    window.removeEventListener('beforeunload', marietta.webcad.WebCADGlobal.pageBeforeUnload);

    try {
      for (let floor = 1; floor <= marietta.webcad.WebCADGlobal.MAX_FLOORS; floor++) {
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION && floor !== 1) continue;
        if (!this.errorCheckExportPlanDXF(floor)) continue;
        const postUrl = `${baseUrl}?floor=${floor}`;
        const res = await fetch(postUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: reqJson,
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const info = await res.json();
        if (info.status === 'SUCCESS' && info.dxf_binary_base64) {
          const date = new Date().toISOString().slice(0,10).replace(/-/g,'');
          const time = new Date();
          const timestamp = `${time.getHours()}${time.getMinutes()}${time.getSeconds()}`;
          const filename = `webcad_${date}_${timestamp}_floor${floor}.dxf`;

          const blob = this.base64ToBlob(info.dxf_binary_base64, 'application/dxf');
          await this.downloadBlob(filename, blob);

          await this.sleep(500); // 次のDLまで少し待つ
        } else {
          console.warn(`floor${floor} のエクスポートに失敗しました`);
        }
      }
    } catch (e) {
      console.error(e);
      marietta.webcad.WebCADGlobal.showAlert(
        marietta.webcad.collection.WebCADMessages.getText('ERROR_EXPORT_DXF_FAIL')
      );
    } finally {
      // ページ更新確認ダイアログを再設定
      setTimeout(() => {
        window.addEventListener('beforeunload', marietta.webcad.WebCADGlobal.pageBeforeUnload);
      }, 60 * 1000);
    }
  };

  private errorCheckExportPlanDXF (floor: number): boolean {
    const hasAnyRoomItems  = (floor: number): boolean => {
      const floorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(floor) as marietta.webcad.layer.FloorLayer;
      if (!floorLayer) return false;
      const roomdown1Items = (floorLayer.layer_roomdown1 as marietta.webcad.layer.ItemLayer)?.getAllChildren() ?? [];
      const roomdown2Items = (floorLayer.layer_roomdown2 as marietta.webcad.layer.ItemLayer)?.getAllChildren() ?? [];
      const roomItems = (floorLayer.layer_room      as marietta.webcad.layer.ItemLayer)?.getAllChildren() ?? [];
      return (roomdown1Items.length + roomdown2Items.length + roomItems.length) > 0;
    }

    // マンションモードは１階固定
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      // 単一フロア判定
      return hasAnyRoomItems(1);
    }

    if (floor === 0) {
      // floor=0 のときは全フロアのどれかに1つでもあれば true
      const max = marietta.webcad.WebCADGlobal.MAX_FLOORS;
      return Array.from({ length: max }, (_, i) => i + 1).some(hasAnyRoomItems);
    } else {
      // 単一フロア判定
      return hasAnyRoomItems(floor);
    }
  }

  /**
   * モジュール選択コンボボックス（選択肢）を作成し、状態を現在の寸法モードに合わせて初期化する。
   * ・選択肢（フリー寸法／モジュール補正）の生成はコンボボックス（view）側に委譲する。
   * ・モード切替に伴うグリッド割の既定は1/2とするが、フリー寸法時は refreshModuleUiForMode によりOFF固定・disabled上書きされる。
   * ※建物種別に依らずモジュール補正は選択可能（マンション・戸建て共通）。
   * ※modulePitch は撮影アプリ/保存データ由来なので、ここでは変更しない。
   */
  createPitchList = () => {
    marietta.webcad.WebCADGlobal.modulePitchCombo?.createOptions();

    // モード切替に伴うグリッド割の既定を設定（表示・入力欄の同期は refreshModuleUiForMode）
    this.snapUnit = SNAP_UNIT_DEFAULT;
    this.refreshModuleUiForMode();
  }

  /**
   * 建具を自動で設置から開口建具を削除
   * @param info
   */
  UpdateRoomWallWithFitting = (info: marietta.webcad.collection.ItemInfoCollection) => {
    try {
      const roomList: marietta.webcad.item.Room[] = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(info.floor, ITEM_MODE_NO.MODE_ROOM_NO)).getAllChildren();
      const fittingStartPoint = WebCADUtil.getPointWithAngleAndDistance(new marietta.core.Point(info.x, info.y), info.rotation, info.width / 2);
      const fittingEndPoint = WebCADUtil.getPointWithAngleAndDistance(new marietta.core.Point(info.x, info.y), info.rotation, -info.width / 2);
      for (let k = 0; k < roomList.length; k += 1) {
        const room = roomList[k];
        const wallList = room.wallObjList;
        for (let i = 0; i < wallList.length; i += 1) {
          const sp = room.itemInfo.globalDotList[wallList[i].index];
          const ep = wallList[i].index === room.itemInfo.globalDotList.length - 1 ? room.itemInfo.globalDotList[0] : room.itemInfo.globalDotList[wallList[i].index + 1];
          if ((Point.distance(sp.point, fittingStartPoint) < ALMOST_ZERO && Point.distance(ep.point, fittingEndPoint) < ALMOST_ZERO)
            || (Point.distance(ep.point, fittingStartPoint) < ALMOST_ZERO && Point.distance(sp.point, fittingEndPoint) < ALMOST_ZERO)) {
            wallList[i].removeWall(false);
            break;
          } else if (WebCADUtil.isPointOnLine(sp.point, ep.point, fittingStartPoint) && WebCADUtil.isPointOnLine(sp.point, ep.point, fittingEndPoint)) {
            const newDot1 = new marietta.webcad.collection.PointCollection();
            const newDot2 = new marietta.webcad.collection.PointCollection();
            if (Point.distance(sp.point, fittingStartPoint) > 0 && Point.distance(ep.point, fittingStartPoint) > 0) {
              newDot1.x = fittingStartPoint.x - room.itemInfo.x;
              newDot1.y = fittingStartPoint.y - room.itemInfo.y;
              newDot1.wall_type = 1;
            }
            if (Point.distance(ep.point, fittingEndPoint) > 0 && Point.distance(sp.point, fittingEndPoint) > 0) {
              newDot2.x = fittingEndPoint.x - room.itemInfo.x;
              newDot2.y = fittingEndPoint.y - room.itemInfo.y;
              newDot2.wall_type = 1;
            }
            const newList: marietta.webcad.collection.PointCollection[] = [];
            for (let j = 0; j < room.itemInfo.dotList.length; j += 1) {
              newList.push(room.itemInfo.dotList[j].clone());
              if (wallList[i].index === j) {
                if (!Number.isNaN(newDot1.x) && !Number.isNaN(newDot2.x)) {
                  (Point.distance(wallList[i].startDot.point, newDot1.point) < Point.distance(wallList[i].startDot.point, newDot2.point)) ? newList.push(newDot1, newDot2) : newList.push(newDot2, newDot1);
                } else {
                  const newDot = Number.isNaN(newDot1.x) ? newDot2 : newDot1;
                  if (!Number.isNaN(newDot.x)) {
                    newList.push(newDot);
                  }
                }
              }
            }
            room.itemInfo.dotList = newList;
            room.reCreateImage();
            const wall = room.wallObjList.find((w) => WebCADUtil.isSimilarLine(
              { p1: new Point(w.startDot.x + room.itemInfo.x, w.startDot.y + room.itemInfo.y), p2: new Point(w.endDot.x + room.itemInfo.x, w.endDot.y + room.itemInfo.y) },
              { p1: fittingStartPoint, p2: fittingEndPoint },
            ));
            if (wall) wall.removeWall(false);
            break;
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * floor画像の取得
   * @param floor
   * @param sizex
   * @param sizey
   * @param minmap
   * @param format
   * @param resolve
   */
  getFloorImage(floor:number, sizex: number, sizey: number, format: number, dim: boolean = false, resolve: Function) {
    // Jsonを文字列に変換
    const reqJson = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
    const url = `${this.cadapi_url}api/image?floor=${floor.toString()}&sizex=${sizex.toString()}&sizey=${sizey.toString()}&minmap=0&image=${format.toString()}&dim=${dim}`;
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: reqJson,
    }).then((response) => {
      if (response.status >= 200 && response.status <= 299) {
        return response.json();
      }
      throw Error(response.statusText);
    }).then((info) => {
      if (resolve) {
        resolve(info);
      }
    }).catch(() => {
      if (resolve) {
        resolve();
      }
    });
  }

  /**
   * ビューモードを有効にする
   */
  enableViewMode(onlyDisableQuoteListEdit: boolean = false) {
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isViewMode()) {
      const disableQuoteListEdit = () => {
        const inputElem = document.querySelectorAll('#quotationListTable input');
        for (let i:number = 0; i < inputElem.length; i += 1) {
          (<HTMLInputElement>inputElem[i]).disabled = true;
        }
      };
      if (onlyDisableQuoteListEdit) {
        disableQuoteListEdit();
        return;
      }
      if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '2D') {
        (<HTMLElement>document.querySelector('#header #headerMenu2D')).style.display = 'none';
        (<HTMLElement>document.querySelector('#header .headerMenuRight')).style.display = 'none';
        const itemMenuCategories = (<HTMLElement>document.querySelector('#itemMenuWrap #itemMenuCategories')).children;
        for (let i:number = 0; i < itemMenuCategories.length; i += 1) {
          (<HTMLElement>itemMenuCategories[i]).style.display = 'none';
        }
        const itemMenuElem = document.querySelectorAll('#itemMenuWrap .itemMenu');
        for (let i:number = 0; i < itemMenuElem.length; i += 1) {
          (<HTMLElement>itemMenuElem[i]).style.display = 'none';
        }
        (<HTMLElement>document.querySelector('#itemControlPanel')).style.display = 'none';
        disableQuoteListEdit();
      } else {
        (<HTMLElement>document.querySelector('#header .for3D')).style.display = 'none';
        (<HTMLElement>document.querySelector('#changeDimensionBtns .changeModeToggleBtn.for3D')).style.display = 'block';
        (<HTMLElement>document.querySelector('#captureScreenshot')).style.display = 'none';
        const itemMenuCategories = document.querySelectorAll('#itemChangeMenuWrap .leftMenuCategories ');
        for (let i:number = 0; i < itemMenuCategories.length; i += 1) {
          for (let j:number = 0; j < itemMenuCategories[i].children.length; j += 1) {
            (<HTMLElement>itemMenuCategories[i].children[j]).style.display = 'none';
          }
        }
        const itemMenuElem = document.querySelectorAll('#itemChangeMenuWrap .itemMenu');
        for (let i:number = 0; i < itemMenuElem.length; i += 1) {
          (<HTMLElement>itemMenuElem[i]).style.display = 'none';
        }
        disableQuoteListEdit();
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    }
  }

    /**
     * PINインポート
     */
    readPIN = (e) => {

        type List = {
            name: string,
            filetype: 'json' | 'jpg',
            promise: Promise<string | HTMLImageElement | Error>
        }

        const file = e.target.files[0];

        // BlobからImageへの変換
        const blobToImage = (file: File): Promise<HTMLImageElement | Error> => new Promise((resolve, reject) => {
          const reader = new FileReader();
          // FileReaderでBLOBをData URLに変換
          reader.onloadend = () => {
            const img = new Image();
            // 画像の読み込みが完了したらPromiseを解決
            img.onload = () => {
              resolve(img);
            };
            // 画像の読み込みに失敗したらPromiseを拒否
            img.onerror = () => {
              reject(new Error('Image loading failed'));
            };
            // FileReadstring
            img.src = <string>reader.result;
          };
          // FileReaderがエラーを検出した場合
          reader.onerror = () => {
            reject(new Error('File reading failed'));
          };
          // BLOBをData URLとして読み込む
          reader.readAsDataURL(file);
        });
        const info:AdditionalPinData = { planData: null, imgBinary: [] };
        const list: List[] = [];
        const decompress = new ZipDeCompression(file);
        decompress.decompress().then((files) => {
          files.forEach((file) => {
            const extension = file.name.split('.').pop();
            if (extension == 'jpg') {
              list.push({
                name: file.name,
                filetype: extension,
                promise: blobToImage(file),
              });
            }

            if (extension == 'json') {
              list.unshift({
                name: file.name,
                filetype: extension,
                promise: file.text(),
              });
            }
          });

          Promise.all(list.map((item) => item.promise)).then((objects) => {
            objects.forEach((object, index) => {
              if (typeof　object === 'string') { // JSON
                console.log(object);
                info.planData = JSON.parse(object);
              }
              if (object instanceof HTMLImageElement) {
                console.log(list[index].name);
                console.log(
                  '%c ',
                  `background-image: url(${object.src}); background-size: 100% 100%; padding: 80px 200px`,
                );
                console.log(object.src);
                info.imgBinary.push({ name: list[index].name, src: object.src });
              }
            });
            //想定していないデータの場合
            if( info.planData == null　|| info.imgBinary.length < 1 || info.imgBinary == null ){
              marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_JSON_IMPORT_LIDAR_ADDITIONAL_PIN_FAIL'));
              return;
            }

            // ピンの存在確認
            const itemList = <marietta.webcad.item.FreeText[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByModeAndFloor(ITEM_MODE_NO.MODE_FREETEXT_NO, marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor)
                                                                                                      .filter((item) => item.itemInfo.id === "txt03_01");
            if (itemList.length) {
              const param = {
                itemList: itemList,
                data: info
              };
              marietta.webcad.WebCADGlobal.showDialog(PinConfirm, false, true, true, true, param);
            } else {
              marietta.webcad.WebCADGlobal.lidarAddPinManager.startImportWizard(info);
            }

          });
        });
    };

    /**
   * viewmode for admin
   */
    isViewMode() {
      return marietta.webcad.WebCADGlobal.webcad2Dmanager.startup_mode === 0;
    }

  /** dataURLからファイル名を取得 */
  public getFileNameFromDataURL(dataURL: string): string {
    try {
      const [header, base64Data] = dataURL.split(',');
      const match = header.match(/:(.*?);/);
      if (!match) {
        throw new Error('Invalid data URL');
      }

      const contentType = match[1];
      const mimeToExtensionMap = {
        'image/jpeg': 'jpg',
        'image/png':  'png',
        'image/gif':  'gif',
      };

      const extension = mimeToExtensionMap[contentType] ?? 'jpg';
      return `${(new Date()).getTime()}_${THREE.MathUtils.generateUUID()}.${extension}`;
    } catch (error) {
      console.error('Error extracting file name from data URL:', error);
      return 'default_filename.jpg';
    }
  }

  /** URLからファイル名を取得する */
  public getFileNameFromURL(url: string): string {
    try {
      const urlObj = new URL(url);
      const pathSegments = urlObj.pathname.split('/');
      const fileName = pathSegments.pop();

      return fileName && fileName.length > 0 ? decodeURIComponent(fileName) : '';
    } catch (error) {
      console.error("Invalid URL:", error);
      return '';
    }
  }

  /** ファイル名取得 */
  public getFileName(_fileName: string, _url: string): string {
    let fileName = _fileName;
    if (!fileName) { // 無かったら名前を付ける
      const extension = _url?.split('.').pop();  // ex) 'sample.jpg' -> 'jpg'
      fileName = `${(new Date()).getTime()}_${THREE.MathUtils.generateUUID()}.${extension}`;
    }
    return fileName;
  }

  /**
   * Data URLからBase64部分を取り出してBlobに変換する例
   */
  public dataURLtoBlob(dataURL: string): Blob {
    const [header, base64Data] = dataURL.split(',');
    const contentType = header.match(/:(.*?);/)[1];
    return this.base64ToBlob(base64Data, contentType);
  }

  /**
   * base64をBlobに変換する関数
   */
  public base64ToBlob(data: string, contentType: string){
    const byteCharacters = this.decodeBase64(data);
      const byteArrays = [];
      const sliceSize = 512;
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        // 一定のサイズごとに処理する
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Uint8Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice[i];
        }
        byteArrays.push(byteNumbers);
      }
      return new Blob(byteArrays, { type: contentType });
  }

  /**
   * Base64をデコードする関数
   * @param base64
   * @returns Uint8Array
   */
  public decodeBase64(base64: string): Uint8Array {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  /**
   * ブラウザ上で Blob データを指定したファイル名でダウンロードさせる。
   *
   * @param {string} filename - ダウンロード時のファイル名。
   * @param {Blob} blob - ダウンロードするデータを表す Blob オブジェクト。
   *
   * @example
   * const blob = new Blob(['Hello world'], { type: 'text/plain' });
   * await downloadBlob('hello.txt', blob);
   */
  private async  downloadBlob(filename: string, blob: Blob) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  /**
   * 指定した時間だけ処理を遅延させる非同期関数。
   *
   * @param {number} ms - 待機するミリ秒数。
   * @returns {Promise<void>} 指定した時間経過後に解決される Promise。
   *
   * @example
   * await sleep(1000); // 1秒待つ
   */
  private sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

  /** 削除されたピンのpin_id配列 */
  public deletePins: string[] = []
  /**
   * ピンの削除
   * 保存時に実行
   */
  public async deletePin(): Promise<void> {
    const pinAry: marietta.webcad.item.PinPicture[] = this.getAllPins();
    // 空文字のid,重複しているidを削除
    this.deletePins = this.deletePins.filter((pinId) => pinId);
    this.deletePins = [...new Set(this.deletePins)];
    // 表示されているピンと削除されたピンの差分を取得
    const deletePins = this.deletePins.filter((pinId) => !pinAry.some((pin) => pin.itemInfo.pin_id === pinId));
    try {
      await Promise.all(deletePins.map(async (pin) => {
        await marietta.webcad.manager.APIManager.deletePin(pin);
        this.deletePins = [];
      }));
    } catch (error) {
      this.deletePins = [];
      console.log(error);
    }
  }

  /** 付帯工事がある&必須項目があるか */
  private hasAuxiliaryConstruction(auxiliaryData: AuxiliaryData): boolean {
    const hasData = <T>(_data: T) => (_data != undefined && _data != null);
    const hasAuxiliaryConstruction = hasData(auxiliaryData);
    if (hasAuxiliaryConstruction) {
      const data = auxiliaryData.auxiliaryDatum;
      return (hasData(data.constructionId) && hasData(data.quantity) &&
              hasData(data.totalPrice) && hasData(data.other_flag));
    }
    return false;
  }

  /**
   * 全階層に配置されているピンを取得する
   */
  public getAllPins(): marietta.webcad.item.PinPicture[] {
    const pinAry: marietta.webcad.item.PinPicture[] = [];
    for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
      const tarLayer: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(i, ITEM_MODE_NO.MODE_FREETEXT_NO);
      pinAry.push(...<marietta.webcad.item.PinPicture[]>tarLayer.getAllChildren());
    }
    return pinAry;
  }

  /**
   * 全ピンで使用済みの画像リンク（Before・After）を取得する
   * 編集中のピンは除外し、ダイアログ上の未確定の状態は呼び出し側で足す
   */
  public getUsedImageLinks(excludeItemInfo: marietta.webcad.collection.ItemInfoCollection = null): LinkType[] {
    return this.getAllPins()
      .filter((pin) => marietta.webcad.WebCADGlobal.isPinPictureItem(pin.itemInfo.id))
      .filter((pin) => pin.itemInfo.guid !== excludeItemInfo?.guid)
      .flatMap((pin) => [...(pin.itemInfo.link ?? []), ...(pin.itemInfo.after_link ?? [])]);
  }

  /**
   * ピンの保存（登録・更新）
   */
  public async savePin(): Promise<void> {
    const pinAry: marietta.webcad.item.PinPicture[] = this.getAllPins();
    // 登録が必要なピンのみ取り出す
    const isRegistPin = (pin: marietta.webcad.item.PinPicture): boolean => pin.itemInfo.is_register_img || (!pin.itemInfo.pin_id && this.hasAuxiliaryConstruction(pin.itemInfo?.auxiliaryData));
    const isUpdatePin = (pin: marietta.webcad.item.PinPicture): boolean => pin.itemInfo.is_register_img || (pin.itemInfo.pin_id && pin.itemInfo.is_pin_update_flg);
    const registerPins = pinAry.filter((pin) => isRegistPin(pin) || isUpdatePin(pin));
    try {
      await Promise.all(registerPins.map(async (pin) => {
        const resPin = await marietta.webcad.manager.APIManager.registerOrUpdatePin(pin);
        if (resPin) {
          pin.itemInfo.is_register_img = false;
          pin.itemInfo.is_pin_update_flg = false;
          pin.itemInfo.pin_id = resPin.pin.id ?? '';
          // berfore画像再設定
          pin.itemInfo.link = [];
          for(let i = 0; i < resPin.pin.before_image_url.length; i++) {
            const befUrl = resPin.pin.before_image_url[i];
            const id = resPin.pin.before_image_id[i];
            if (befUrl) {
              // 画像名でファイルを作成するか否かサーバー側は識別しているようなので、nameを取得してセットする
              const name = marietta.WebCADGlobal.webcad2Dmanager.getFileNameFromURL(befUrl);
              pin.itemInfo.link.push({ id: id, name : name, url: befUrl });
              if (pin.itemInfo.remarks.length > 0 && pin.itemInfo.remarks[i]) {
                pin.itemInfo.remarks[i].id = id; // リンクと備考のIDを一致させるため
              }
            }
          }
          // after画像再設定
          const prevAfter_link = [...pin.itemInfo.after_link];
          pin.itemInfo.after_link = [];
          for(let i = 0; i < prevAfter_link.length; i++) {
            if(prevAfter_link[i].url || prevAfter_link[i].binary) {
              const afUrl = resPin.pin.after_image_url[i];
              const id = resPin.pin.after_image_id[i];
              if (afUrl) {
                // 画像名でファイルを作成するか否かサーバー側は識別しているようなので、nameを取得してセットする
                const name = marietta.WebCADGlobal.webcad2Dmanager.getFileNameFromURL(afUrl);
                pin.itemInfo.after_link.push({ id: id, name: name, url: afUrl });
              } else {
                pin.itemInfo.after_link.push({id: "", name: "", url: ""});
              }
            } else {
                pin.itemInfo.after_link.push({id: "", name: "", url: ""});
            }
          }
        } else {
          return await Promise.reject("Pin registration failed.");
        }
      }));
    } catch (error) {
      return await Promise.reject("Pin registration failed.");
    }
  }

  /**
   * 対象のピンが乗っている部屋を取得
   */
  public getRoomWithPin(pin: marietta.webcad.collection.ItemInfoCollection): marietta.webcad.item.Room | null{
    const rooms = <marietta.webcad.item.Room[]>marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(pin.floor, ITEM_MODE_NO.MODE_ROOM_NO).getAllChildren();
    const roomPointAry = rooms.map((room) => room.itemInfo.getItemPointAry()); // 部屋囲みの配列
    const pinPoint = new marietta.core.Point(pin.x, pin.y);
    const roomIndex = roomPointAry.findIndex((points) => {
      return points.IsInclude(pinPoint) !== marietta3d.AutoGen.utils.RC_INCLUDE.OUTSIDE
    });
    return roomIndex >= 0 ? rooms[roomIndex] : null;
  }
}
